/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { SvgIcon } from "@material-ui/core";

export const AppIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 64.596 64.635">
    <path
      d="M395.776,176.414a27.329,27.329,0,0,1-27.111-25.533c-.02-.335-.041-.67-.048-1.009q-.008-.312-.008-.626c0-.6.021-1.215.062-1.827h14.576l1.462,3.462,6.952,16.469a4.513,4.513,0,0,0,4.12,2.736l.129,0a4.545,4.545,0,0,0,4.146-2.535l8.077-16.672,1.677-3.462h18.244l-.083-.969a32.035,32.035,0,0,0-1.374-6.925c-.073-.231-.154-.457-.232-.685a32.308,32.308,0,0,0-61.179,0h5.5a27.156,27.156,0,0,1,50.176,0c.172.413.338.83.49,1.255.257.716.484,1.443.679,2.173H409.506a4.609,4.609,0,0,0-4.152,2.535l-2.945,6.077-6.473,13.359-5.64-13.359-2.48-5.875a4.561,4.561,0,0,0-4.243-2.737H364.21l-.142.72a32.5,32.5,0,0,0-.488,3.462c-.081.94-.122,1.881-.122,2.8,0,.223,0,.444.009.665.006.325.027.647.043.97a32.308,32.308,0,0,0,64.532,0h-5.155A27.329,27.329,0,0,1,395.776,176.414Z"
      transform="translate(-363.458 -116.929)"
    />
  </SvgIcon>
);

export const TriangleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 52 49">
    <path
      fill="#fcc830"
      d="M17.611,13.825a1.509,1.509,0,0,1-1.286,2.262H1.486A1.509,1.509,0,0,1,.2,13.825L7.62.754a1.474,1.474,0,0,1,2.571,0Zm-8.705-2.7a1.445,1.445,0,1,0,1.422,1.445A1.434,1.434,0,0,0,8.906,11.122Zm-1.35-5.2L7.785,10.2a.374.374,0,0,0,.371.356h1.5a.374.374,0,0,0,.371-.356l.229-4.273a.374.374,0,0,0-.371-.4H7.926a.374.374,0,0,0-.37.4Z"
    />
  </SvgIcon>
);

export const PhoneRoundIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect
      fill="#fcc830"
      width="25"
      height="25"
      rx="3"
      transform="translate(0.061)"
    />
    <path
      transform="translate(-1.062 -0.696)"
      fill="#133d59"
      d="M12.692,11.221a7.087,7.087,0,0,0-1.482-1.007c-.444-.217-.607-.212-.921.018-.262.192-.431.371-.732.3A4.37,4.37,0,0,1,8.086,9.43,4.4,4.4,0,0,1,7,7.935c-.064-.308.112-.478.3-.744.226-.319.233-.485.018-.936A7.074,7.074,0,0,0,6.322,4.75c-.323-.328-.4-.257-.574-.192a3.247,3.247,0,0,0-.525.284,1.6,1.6,0,0,0-.631.677c-.125.275-.27.786.468,2.122a11.828,11.828,0,0,0,2.049,2.777h0l0,0,0,0h0A11.718,11.718,0,0,0,9.847,12.5c1.315.751,1.818.6,2.089.476a1.568,1.568,0,0,0,.666-.641,3.338,3.338,0,0,0,.279-.534C12.945,11.623,13.017,11.55,12.692,11.221Z"
    />
    {/* <path
      fill="#133d59"
      d="M12.692,11.221a7.087,7.087,0,0,0-1.482-1.007c-.444-.217-.607-.212-.921.018-.262.192-.431.371-.732.3A4.37,4.37,0,0,1,8.086,9.43,4.4,4.4,0,0,1,7,7.935c-.064-.308.112-.478.3-.744.226-.319.233-.485.018-.936A7.074,7.074,0,0,0,6.322,4.75c-.323-.328-.4-.257-.574-.192a3.247,3.247,0,0,0-.525.284,1.6,1.6,0,0,0-.631.677c-.125.275-.27.786.468,2.122a11.828,11.828,0,0,0,2.049,2.777h0l0,0,0,0h0A11.718,11.718,0,0,0,9.847,12.5c1.315.751,1.818.6,2.089.476a1.568,1.568,0,0,0,.666-.641,3.338,3.338,0,0,0,.279-.534C12.945,11.623,13.017,11.55,12.692,11.221Z"
      transform="translate(-1.062 -0.696)"
    /> */}
  </SvgIcon>
);

export const CoverIcon = (props) => (
  <SvgIcon
    {...props}
    width="65.183"
    height="65.183"
    viewBox="0 0 65.183 65.183"
  >
    <g
      id="Group_282"
      data-name="Group 282"
      transform="translate(-745 -1657.881)"
    >
      <rect
        id="Rectangle_427"
        data-name="Rectangle 427"
        className="cls-1"
        width="63.183"
        height="63.183"
        fill="none"
        stroke="#133d59"
        strokeWidth="2"
        transform="translate(746 1658.881)"
      />
      <line
        id="Line_76"
        fill="none"
        stroke="#133d59"
        y2="63.183"
        strokeWidth="2"
        transform="translate(785.742 1658.881)"
      />
      <line
        id="Line_77"
        fill="none"
        stroke="#133d59"
        x2="63.183"
        strokeWidth="2"
        transform="translate(746 1705.052)"
      />
      <text
        id="KENYA"
        fontSize="9"
        fontFamily="Arial-BoldMT, Arial"
        fontWeight="700"
        fill="#133d59"
        transform="translate(751 1717)"
      >
        <tspan x="0" y="0">
          UGANDA
        </tspan>
      </text>
      <g
        id="Group_241"
        data-name="Group 241"
        transform="translate(788.739 1674.099)"
      >
        <g id="Group_240" data-name="Group 240" transform="translate(0)">
          <path
            id="Path_1049"
            data-name="Path 1049"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-391.255,1210.832a14,14,0,0,0,.817,4.169s.368.94.143,1.41c0,0-1.165,1.533.266,2.289,0,0,1,.2.838,1.062-.08.419-.317.807-.387,1.239-.031.194-.086.514.072.673.315.318.521-.26.806-.238.174.013.246.242.226.39-.064.472-1.166,1.272-.5,1.813.279.227.516-.157.782-.026.222.109.239.525.216.734s-.2.456-.124.681a.31.31,0,0,0,.54.135c.1-.106.026-.229.208-.2.118.021.169.165.2.261a1.579,1.579,0,0,1-.06.72c-.169.916.874.138,1.193.339.234.148.184.37.116.595-.1.32-.338.971.3.782.187-.056.326-.251.517-.123s.147.427.118.621c-.073.485-.02.841.571.871a1.1,1.1,0,0,0,.852-.435c.174-.221.142-.718.347-.848.511.158.141.792.305,1.119a1.346,1.346,0,0,0,1.166.459c.387-.144.462-.851.6-1.168.309-.71.514.208.7.417.241.269.709.074.857-.2.19-.346-.056-.811.135-1.14.566-.047,1.116,1.037,1.705.376a1.723,1.723,0,0,0,.152-1.574c-.09-.282-.192-.448.165-.561.26-.082.562.045.772-.187a1.956,1.956,0,0,0,.137-1.3c-.079-.435-.2-.727.143-1.068.179-.178.534-.279.614-.54s-.163-.648-.225-.9a.92.92,0,0,1,.136-.708,3.918,3.918,0,0,1,.886-.981,4.418,4.418,0,0,0,.769-3.024,10.354,10.354,0,0,0-.414-2.527,3.859,3.859,0,0,1-.049-.742,5.286,5.286,0,0,1,.06-1.336,9.24,9.24,0,0,0,.316-2.773c-.045-.46-.265-.845-.792-.613-.356.157-.446.6-.749.832-.406.306-.7-.015-.953-.341a.889.889,0,0,0-1.041-.347c-.362.133-.466.645-.9.551s-.432-.588-.873-.658c-.515-.082-.62.242-.959.537-.2.174-.308.106-.491-.1-.158-.174-.188-.259-.422-.341-.5-.174-.771.094-.964.546-.412-.086-.643-.556-1.057-.595a.893.893,0,0,0-.622.136c-.18.133-.216.391-.441.437-.447.09-.638-.535-1.119-.306a.9.9,0,0,0-.414.469c-.073.145-.215.608-.375.656-.262.079-.561-.459-.784-.526a1.008,1.008,0,0,0-.925.224c-.274.245-.349.544-.743.484-.584-.088-.867-.7-1.491-.7S-391.218,1210.3-391.255,1210.832Z"
            transform="translate(391.255 -1208.712)"
          />
          <path
            id="Path_1050"
            data-name="Path 1050"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-362.369,1235.961a2.963,2.963,0,0,1,.508.953,1.724,1.724,0,0,1-1.966,2.189,1.513,1.513,0,0,1-1.381-1.5,3.492,3.492,0,0,1,.694-2.318"
            transform="translate(372.606 -1227.752)"
          />
          <path
            id="Path_1051"
            data-name="Path 1051"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-380.442,1236.729a2.94,2.94,0,0,0,.164,1.456c.145.383.531.577.8.833a4.582,4.582,0,0,1,1.159,2.349,1.375,1.375,0,0,0,.252.564"
            transform="translate(383.527 -1228.785)"
          />
          <line
            id="Line_78"
            data-name="Line 78"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            y2="2.89"
            transform="translate(8.977 11.361)"
          />
          <path
            id="Path_1052"
            data-name="Path 1052"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-361.966,1256.074a2.333,2.333,0,0,1-1.119,2.065c-1.656.731-2.271-1.815-1.867-2.9a1.791,1.791,0,0,1,2.142-1.085C-362.132,1254.416-361.941,1255.447-361.966,1256.074Z"
            transform="translate(372.496 -1241.203)"
          />
          <path
            id="Path_1053"
            data-name="Path 1053"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-346.3,1237.522c0,.852.277,1.758-.483,2.35a5.8,5.8,0,0,0-1.595,1.485"
            transform="translate(360.534 -1229.353)"
          />
          <path
            id="Path_1054"
            data-name="Path 1054"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-355.2,1254.325a2.975,2.975,0,0,1,1.261-.7c.838-.158,1.245.725,1.194,1.415a1.712,1.712,0,0,1-.846,1.335,2.722,2.722,0,0,1-1.466.263"
            transform="translate(365.423 -1240.878)"
          />
          <path
            id="Path_1055"
            data-name="Path 1055"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-370.319,1254.325a2.975,2.975,0,0,0-1.261-.7c-.838-.158-1.245.725-1.194,1.415a1.711,1.711,0,0,0,.847,1.335,2.722,2.722,0,0,0,1.466.263"
            transform="translate(378.018 -1240.878)"
          />
          <path
            id="Path_1056"
            data-name="Path 1056"
            className="cls-3"
            d="M-350.088,1228.119c.271-.007.1.241.01.35a5.919,5.919,0,0,1-.638.631,10.538,10.538,0,0,0-.714.791c-.193.218-.5.52-.81.316-.77-.513.167-1.208.631-1.488a5.835,5.835,0,0,1,.724-.369A2.352,2.352,0,0,1-350.088,1228.119Z"
            transform="translate(363.512 -1222.616)"
          />
          <path
            id="Path_1057"
            data-name="Path 1057"
            className="cls-3"
            fill="none"
            stroke="#133d59"
            strokeMiterlimit="10"
            d="M-376.569,1231.155c-.257.086-.009.259.11.332a5.934,5.934,0,0,0,.815.376,10.649,10.649,0,0,1,.941.5c.256.139.65.317.869.021.549-.745-.569-1.078-1.1-1.183a5.932,5.932,0,0,0-.806-.1A2.361,2.361,0,0,0-376.569,1231.155Z"
            transform="translate(380.814 -1224.744)"
          />
          <path
            id="Path_1058"
            data-name="Path 1058"
            className="cls-4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M-354.108,1224.55a2.765,2.765,0,0,1,1.742-1.226"
            transform="translate(364.641 -1219.181)"
          />
          <path
            id="Path_1059"
            data-name="Path 1059"
            className="cls-4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M-356.129,1219.924a2.7,2.7,0,0,1,1.181-1.033"
            transform="translate(366.089 -1216.004)"
          />
          <path
            id="Path_1060"
            data-name="Path 1060"
            className="cls-4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M-372.956,1225.482a2.764,2.764,0,0,0-2.038-.619"
            transform="translate(379.605 -1220.275)"
          />
          <path
            id="Path_1061"
            data-name="Path 1061"
            className="cls-4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M-368.056,1219.924a2.7,2.7,0,0,0-1.181-1.033"
            transform="translate(375.48 -1216.004)"
          />
        </g>
      </g>
      <path
        id="Path_1062"
        data-name="Path 1062"
        className="cls-5"
        fill="#133d59"
        d="M-516.374,1183.191l-11.372,28.625h3.307l4.355-10.3h5l.081,10.3h2.839v-28.625Zm1.28,14.313h-3.6l3.6-8.541Z"
        transform="translate(1277.785 483.672)"
      />
      <path
        id="Path_1063"
        data-name="Path 1063"
        className="cls-5"
        fill="#133d59"
        d="M-459.411,1183.191l-11.372,28.625h3.307l4.355-10.3h5l.081,10.3h2.839v-28.625Zm1.28,14.313h-3.6l3.6-8.541Z"
        transform="translate(1236.973 483.672)"
      />
    </g>
  </SvgIcon>
);

export const PartIcon = (props) => (
  <SvgIcon {...props} width="67.25" height="67.25" viewBox="0 0 67.25 67.25">
    <path
      id="Icon_ionic-md-cog"
      fill="none"
      stroke="#133d59"
      strokeWidth="2"
      d="M67.5,39.536V30.214H62.446a28.225,28.225,0,0,0-1.355-5.1l4.369-2.52L60.8,14.528l-4.369,2.52A28.185,28.185,0,0,0,52.7,13.319l2.52-4.369L47.153,4.289l-2.52,4.369a27.073,27.073,0,0,0-5.1-1.355V2.25H30.214V7.3a28.225,28.225,0,0,0-5.1,1.355L22.6,4.289,14.528,8.95l2.52,4.369a28.185,28.185,0,0,0-3.729,3.729L8.95,14.528,4.289,22.6l4.369,2.52a27.073,27.073,0,0,0-1.355,5.1H2.25v9.321H7.3a28.225,28.225,0,0,0,1.355,5.1l-4.369,2.52L8.95,55.222l4.369-2.52a28.184,28.184,0,0,0,3.729,3.729L14.528,60.8,22.6,65.461l2.52-4.369a27.073,27.073,0,0,0,5.1,1.355V67.5h9.321V62.446a28.225,28.225,0,0,0,5.1-1.355l2.52,4.369L55.222,60.8,52.7,56.431A28.184,28.184,0,0,0,56.431,52.7l4.369,2.52,4.661-8.069-4.369-2.52a27.073,27.073,0,0,0,1.355-5.1ZM34.875,30.214a4.661,4.661,0,1,1-4.661,4.661A4.656,4.656,0,0,1,34.875,30.214ZM18.155,47.546A20.93,20.93,0,0,1,13.9,34.875a22.228,22.228,0,0,1,.16-2.622l6.831,2.491v.131a14.005,14.005,0,0,0,1.937,7.108Zm5.928-21.556L17.252,23.5a20.949,20.949,0,0,1,12.963-9.074v7.268A14.087,14.087,0,0,0,24.083,25.991ZM34.875,55.848a20.832,20.832,0,0,1-9.584-2.316l4.675-5.564a14,14,0,0,0,9.817,0l4.675,5.564A20.832,20.832,0,0,1,34.875,55.848Zm4.661-34.154V14.426A20.949,20.949,0,0,1,52.5,23.5l-6.831,2.491A14.087,14.087,0,0,0,39.536,21.694ZM51.6,47.546,46.92,41.983a14.005,14.005,0,0,0,1.937-7.108v-.131l6.831-2.491a22.229,22.229,0,0,1,.16,2.622A20.93,20.93,0,0,1,51.6,47.546Z"
      transform="translate(-1.25 -1.25)"
    />
  </SvgIcon>
);

export const SpeedoMeterIcon = (props) => (
  <SvgIcon
    {...props}
    width="72.322"
    height="72.322"
    viewBox="0 0 72.322 72.322"
  >
    <g
      id="Icon_ionic-md-speedometer"
      data-name="Icon ionic-md-speedometer"
      transform="translate(-2.375 -2.375)"
    >
      <path
        id="Path_805"
        data-name="Path 805"
        fill="none"
        stroke="#133d59"
        strokeWidth="2"
        d="M9,29.25H52.275v8.114H9Z"
        transform="translate(7.898 36.333)"
      />
      <path
        id="Path_806"
        data-name="Path 806"
        fill="none"
        stroke="#133d59"
        strokeWidth="2"
        d="M25.849,31.258a5.409,5.409,0,1,0-1.488-10.616L13.086,12.41,12.41,13l8.266,11.275a5.277,5.277,0,0,0-.237,1.572A5.4,5.4,0,0,0,25.849,31.258Z"
        transform="translate(12.687 12.687)"
      />
      <path
        id="Path_807"
        data-name="Path 807"
        fill="none"
        stroke="#133d59"
        strokeWidth="2"
        d="M38.536,3.375a35.153,35.153,0,0,0-27.706,56.8h9.94l.676-.676,3.736-3.736L21.31,51.89l-3.736,3.719a26.944,26.944,0,0,1-5.95-14.369H16.9V35.831H11.624a26.944,26.944,0,0,1,5.95-14.369l3.736,3.719,3.871-3.871-3.719-3.736a26.944,26.944,0,0,1,14.369-5.95V16.9h5.409V11.624a26.944,26.944,0,0,1,14.369,5.95L51.89,21.31l3.871,3.871L59.5,21.463a26.944,26.944,0,0,1,5.95,14.369H60.173v5.409h5.274A26.944,26.944,0,0,1,59.5,55.609L55.761,51.89,51.89,55.761,55.626,59.5l.676.676h9.94a35.153,35.153,0,0,0-27.706-56.8Z"
        transform="translate(0 0)"
      />
    </g>
  </SvgIcon>
);

export const CustomerServiceIcon = (props) => (
  <SvgIcon {...props} width="79.54" height="72.392" viewBox="0 0 79.54 72.392">
    <g
      id="Group_165"
      data-name="Group 165"
      transform="translate(-3704.869 -4439.955)"
    >
      <path
        id="Path_808"
        data-name="Path 808"
        stroke="#133d59"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3724.792,4494.2a28.72,28.72,0,0,1-.514-5.436v-14.9s3.16-4.115,12.226-1.21c0,0,15.326,5.809,28.062-9.2l5.474,10.408v14.9c0,14.171-10.244,25.657-22.881,25.657a21.644,21.644,0,0,1-16.157-7.487"
        transform="translate(-2.514 -3.072)"
      />
      <path
        id="Path_809"
        fill="none"
        stroke="#133d59"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M3714.553,4473.235a32.28,32.28,0,0,1,64.561,0"
        transform="translate(-1.186)"
      />
      <path
        id="Path_810"
        data-name="Path 810"
        stroke="#133d59"
        strokeWidth="2"
        strokeMiterlimit="10"
        fill="#fff"
        d="M3715.691,4474.164h-3.173a6.648,6.648,0,0,0-6.649,6.648v5.614a6.648,6.648,0,0,0,6.649,6.648h3.173Z"
        transform="translate(0 -4.535)"
      />
      <path
        id="Path_811"
        data-name="Path 811"
        stroke="#133d59"
        strokeWidth="2"
        strokeMiterlimit="10"
        fill="#fff"
        d="M3784.3,4474.164h3.173a6.648,6.648,0,0,1,6.649,6.648v5.614a6.648,6.648,0,0,1-6.649,6.648H3784.3Z"
        transform="translate(-10.71 -4.535)"
      />
      <path
        id="Path_812"
        data-name="Path 812"
        fill="#fff"
        stroke="#133d59"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M3748.139,4505.724c0,2.206-1.012,3.994-2.261,3.994h-5.193c-1.249,0-2.26-1.788-2.26-3.994h0c0-2.206,1.012-3.994,2.26-3.994h5.193c1.249,0,2.261,1.788,2.261,3.994Z"
        transform="translate(-4.445 -8.299)"
      />
      <path
        id="Path_813"
        data-name="Path 813"
        stroke="#133d59"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3712.55,4496.066v8.884h22.4"
        transform="translate(-0.912 -7.526)"
      />
    </g>
  </SvgIcon>
);

export const MobileIcon = (props) => (
  <SvgIcon
    {...props}
    width="14.651"
    height="25.855"
    viewBox="0 0 14.651 25.855"
  >
    <g id="Group_20" data-name="Group 20" transform="translate(-110.933)">
      <g
        id="Group_11"
        data-name="Group 11"
        transform="translate(115.673 1.293)"
      >
        <g id="Group_10" data-name="Group 10" transform="translate(0)">
          <path
            id="Path_28"
            data-name="Path 28"
            d="M209.541,25.6h-4.309a.431.431,0,0,0,0,.862h4.309a.431.431,0,0,0,0-.862Z"
            transform="translate(-204.801 -25.6)"
            fill="#149fcb"
          />
        </g>
      </g>
      <g
        id="Group_13"
        data-name="Group 13"
        transform="translate(122.568 1.293)"
      >
        <g id="Group_12" data-name="Group 12" transform="translate(0)">
          <path
            id="Path_29"
            data-name="Path 29"
            d="M342.2,25.6h-.431a.431.431,0,1,0,0,.862h.431a.431.431,0,0,0,0-.862Z"
            transform="translate(-341.334 -25.6)"
            fill="#149fcb"
          />
        </g>
      </g>
      <g
        id="Group_15"
        data-name="Group 15"
        transform="translate(116.535 21.977)"
      >
        <g id="Group_14" data-name="Group 14">
          <path
            id="Path_30"
            data-name="Path 30"
            d="M224.126,435.2h-1.07a1.19,1.19,0,0,0-1.189,1.189v.208a1.19,1.19,0,0,0,1.188,1.188h1.07a1.19,1.19,0,0,0,1.189-1.188v-.208A1.19,1.19,0,0,0,224.126,435.2Zm.327,1.4a.327.327,0,0,1-.327.327h-1.07a.327.327,0,0,1-.327-.327v-.208a.327.327,0,0,1,.327-.327h1.07a.327.327,0,0,1,.327.327Z"
            transform="translate(-221.867 -435.2)"
            fill="#149fcb"
          />
        </g>
      </g>
      <g id="Group_17" data-name="Group 17" transform="translate(110.933)">
        <g id="Group_16" data-name="Group 16" transform="translate(0)">
          <path
            id="Path_31"
            data-name="Path 31"
            d="M124.027,0H112.491a1.56,1.56,0,0,0-1.558,1.558V24.3a1.56,1.56,0,0,0,1.558,1.558h11.536a1.56,1.56,0,0,0,1.558-1.557V1.558A1.56,1.56,0,0,0,124.027,0Zm.7,24.3a.7.7,0,0,1-.7.7H112.491a.7.7,0,0,1-.7-.7V1.558a.7.7,0,0,1,.7-.7h11.536a.7.7,0,0,1,.7.7V24.3Z"
            transform="translate(-110.933)"
            fill="#149fcb"
          />
        </g>
      </g>
      <g
        id="Group_19"
        data-name="Group 19"
        transform="translate(110.933 2.586)"
      >
        <g id="Group_18" data-name="Group 18">
          <path
            id="Path_32"
            data-name="Path 32"
            d="M125.154,51.2H111.365a.431.431,0,0,0-.431.431v18.1a.431.431,0,0,0,.431.431h13.789a.431.431,0,0,0,.431-.431v-18.1A.431.431,0,0,0,125.154,51.2Zm-.431,18.1H111.8V52.062h12.927Z"
            transform="translate(-110.934 -51.2)"
            fill="#149fcb"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const RightArrowIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 21.654 14.436">
    <path
      d="M21.522,92.232l-6.767-6.767a.451.451,0,0,0-.638.638l6,6H.451a.451.451,0,0,0,0,.9H20.114l-6,6a.451.451,0,1,0,.638.638l6.767-6.767A.451.451,0,0,0,21.522,92.232Z"
      transform="translate(0 -85.333)"
      fill="#fff"
    />
  </SvgIcon>
);

export const AlertInfoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 26.89 26.889">
    <g id="Group_202" data-name="Group 202" transform="translate(0 0)">
      <path
        id="Path_463"
        data-name="Path 463"
        d="M2587.99,341.093a13.445,13.445,0,1,1,9.507-3.938A13.355,13.355,0,0,1,2587.99,341.093Zm0-24.962a11.518,11.518,0,1,0,11.518,11.518A11.531,11.531,0,0,0,2587.99,316.131Z"
        transform="translate(-2574.546 -314.204)"
        fill="#f06b6b"
      />
    </g>
    <text
      id="_"
      data-name="!"
      transform="translate(11 18)"
      fill="#e60909"
      fontSize="14"
      fontFamily="Quicksand"
      fontWeight="700"
    >
      <tspan x="0" y="0">
        !
      </tspan>
    </text>
  </SvgIcon>
);

export const AlertInfoOutlineIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <g fill="none" stroke="#ff0707" strokeWidth="2" opacity="0.694">
      <circle cx="7" cy="7" r="7" stroke="none" />
      <circle cx="7" cy="7" r="6" fill="none" />
    </g>
  </SvgIcon>
);

export const DownArrowIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12.8 8.6">
    <g
      id="Group_192"
      data-name="Group 192"
      transform="translate(-1109.1 -364.2)"
    >
      <line
        x2="6"
        y2="8"
        transform="translate(1109.5 364.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <line
        x1="6"
        y2="8"
        transform="translate(1115.5 364.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export const EditIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 17 17">
    <g
      id="register_1_"
      data-name="register (1)"
      transform="translate(34.798 3.798)"
    >
      <g
        id="Rectangle_54"
        data-name="Rectangle 54"
        transform="translate(-34.798 -3.798)"
        fill="none"
        stroke="#5a5656"
        strokeWidth="1"
      >
        <rect width="17" height="17" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="16" height="16" rx="1.5" fill="none" />
      </g>
      <path
        id="penso"
        d="M11.735,19.991a.344.344,0,0,1-.241-.1.341.341,0,0,1-.093-.308l.482-2.411A.334.334,0,0,1,11.975,17l5.3-5.3a1.025,1.025,0,0,1,1.446,0l.964.964a1.024,1.024,0,0,1,0,1.446l-5.3,5.3a.339.339,0,0,1-.175.093l-2.411.482A.362.362,0,0,1,11.735,19.991Zm.8-2.584-.361,1.808,1.808-.361,5.231-5.231a.341.341,0,0,0,0-.482l-.964-.964a.341.341,0,0,0-.482,0Zm1.614,1.761h.007Z"
        transform="translate(-42.21 -11.208)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
    </g>
  </SvgIcon>
);

export const EditOutlineIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 10 10">
    <g id="register_1_" data-name="register (1)" transform="translate(35 4)">
      <g
        id="Rectangle_54"
        data-name="Rectangle 54"
        transform="translate(-35 -4)"
        fill="none"
        stroke="#149fcb"
        strokeWidth="0.4"
      >
        <rect width="10" height="10" rx="2" stroke="none" />
        <rect x="0.2" y="0.2" width="9.6" height="9.6" rx="1.8" fill="none" />
      </g>
      <path
        id="penso"
        d="M11.589,16.313a.2.2,0,0,1-.138-.057.2.2,0,0,1-.053-.176l.276-1.379a.191.191,0,0,1,.053-.1l3.034-3.034a.586.586,0,0,1,.827,0l.552.552a.586.586,0,0,1,0,.827L13.105,15.98a.194.194,0,0,1-.1.053l-1.379.276A.207.207,0,0,1,11.589,16.313Zm.456-1.478-.207,1.034,1.034-.207,2.993-2.993a.2.2,0,0,0,0-.276l-.552-.552a.2.2,0,0,0-.276,0Zm.923,1.007h0Z"
        transform="translate(-44 -13)"
        fill="#149fcb"
      />
    </g>
  </SvgIcon>
);
export const LockIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12.077 16.75">
    <g id="Group_176" data-name="Group 176" transform="translate(-65.8)">
      <g id="Group_173" data-name="Group 173" transform="translate(65.8)">
        <g id="Group_172" data-name="Group 172" transform="translate(0)">
          <path
            id="Path_441"
            data-name="Path 441"
            d="M76.276,7.123V4.471a4.448,4.448,0,0,0-1.328-3.2A4.306,4.306,0,0,0,71.89,0h-.057A4.46,4.46,0,0,0,67.4,4.471V7.123a1.811,1.811,0,0,0-1.6,1.822V14.9a1.835,1.835,0,0,0,1.822,1.847h8.434A1.835,1.835,0,0,0,77.877,14.9V8.945A1.82,1.82,0,0,0,76.276,7.123ZM68.1,4.471h0A3.758,3.758,0,0,1,71.837.7h0a3.678,3.678,0,0,1,2.606,1.072,3.76,3.76,0,0,1,1.115,2.7V7.127h-.781V4.471A2.992,2.992,0,0,0,73.9,2.322a2.879,2.879,0,0,0-2.035-.845H71.84a2.974,2.974,0,0,0-2.954,2.99v2.66H68.1V4.471Zm5.969,0V7.127H69.6V4.471a2.261,2.261,0,0,1,2.244-2.28h.021A2.178,2.178,0,0,1,73.4,2.83,2.289,2.289,0,0,1,74.074,4.471ZM77.2,14.914h0a1.126,1.126,0,0,1-1.126,1.126H67.636a1.126,1.126,0,0,1-1.126-1.126V8.963a1.126,1.126,0,0,1,1.126-1.126h8.437A1.126,1.126,0,0,1,77.2,8.963v5.952Z"
            transform="translate(-65.8)"
            fill="#707070"
          />
        </g>
      </g>
      <g
        id="Group_175"
        data-name="Group 175"
        transform="translate(70.555 10.792)"
      >
        <g id="Group_174" data-name="Group 174" transform="translate(0)">
          <path
            id="Path_442"
            data-name="Path 442"
            d="M202.211,304.827a1.28,1.28,0,1,0-1.584,1.584v.994a.355.355,0,0,0,.71,0v-.994A1.277,1.277,0,0,0,202.211,304.827Zm-1.229.923a.572.572,0,1,1,.572-.572A.571.571,0,0,1,200.982,305.75Z"
            transform="translate(-199.7 -303.9)"
            fill="#707070"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CheckedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <g transform="translate(-1376 -533)">
      <g
        transform="translate(1376 533)"
        fill="none"
        stroke="#00bc76"
        strokeWidth="2"
        opacity="0.694"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6" fill="none" />
      </g>
      <g transform="translate(1379.596 537.916)">
        <g transform="translate(0 0)">
          <path
            d="M127.951,64.424a.328.328,0,0,0-.463,0l-3.932,3.922L122.137,66.8a.328.328,0,0,0-.482.444l1.65,1.792a.327.327,0,0,0,.234.106h.007a.328.328,0,0,0,.231-.1l4.174-4.163A.328.328,0,0,0,127.951,64.424Z"
            transform="translate(-121.568 -64.327)"
            fill="#4ed0a0"
            stroke="#4ed0a0"
            strokeWidth="1"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CheckedOutlineIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 13.283 10.084">
    <path
      d="M133.6,64.509a.618.618,0,0,0-.874,0L125.315,71.9,122.64,69a.618.618,0,0,0-.909.837l3.11,3.378a.617.617,0,0,0,.441.2h.013a.619.619,0,0,0,.436-.18l7.869-7.848A.618.618,0,0,0,133.6,64.509Z"
      transform="translate(-121.568 -64.327)"
      fill="#6d6c6c"
      stroke="#6d6c6c"
      strokeWidth="1"
    />
  </SvgIcon>
);

export const EmailIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 14.229 12.429">
    <g id="email_1_" data-name="email (1)" transform="translate(0 -28.756)">
      <g id="Group_247" data-name="Group 247" transform="translate(0 28.756)">
        <g id="Group_246" data-name="Group 246" transform="translate(0 0)">
          <path
            id="Path_1318"
            data-name="Path 1318"
            d="M14.162,32.746,12.1,31.291V29.165a.458.458,0,0,0-.392-.409H2.682a.458.458,0,0,0-.392.409v2.11L.147,32.746A.36.36,0,0,0,0,33.008v7.768a.474.474,0,0,0,.409.409H13.982c.18,0,.245-.213.245-.409V33.008C14.228,32.91,14.244,32.812,14.162,32.746ZM12.1,32.076l1.406.965L12.1,34.1ZM2.944,29.41h8.5v5.2L7.2,37.816,2.944,34.611v-5.2ZM2.29,32.059V34.12L.883,33.041ZM.654,33.711l4.579,3.467L.654,40.269Zm.785,6.819L5.789,37.6l1.161.883a.392.392,0,0,0,.229.082c.065,0,.1-.033.164-.082l1.21-.932,4.4,2.976Zm12.134-.376L9.093,37.145l4.481-3.434Z"
            transform="translate(0 -28.756)"
            fill="#5a5656"
          />
          <path
            id="Path_1319"
            data-name="Path 1319"
            d="M136.164,97.328h1.472a.327.327,0,0,0,0-.654h-1.472a.327.327,0,0,0,0,.654Z"
            transform="translate(-131.585 -94.548)"
            fill="#5a5656"
          />
          <path
            id="Path_1320"
            data-name="Path 1320"
            d="M136.164,144.349H141.4a.327.327,0,1,0,0-.654h-5.233a.327.327,0,0,0,0,.654Z"
            transform="translate(-131.585 -140.097)"
            fill="#5a5656"
          />
          <path
            id="Path_1321"
            data-name="Path 1321"
            d="M141.724,191.042a.327.327,0,0,0-.327-.327h-5.233a.327.327,0,0,0,0,.654H141.4A.327.327,0,0,0,141.724,191.042Z"
            transform="translate(-131.585 -185.645)"
            fill="#5a5656"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const PrinterIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12.429 12.429">
    <g id="printer" transform="translate(0.001)">
      <path
        id="Path_1314"
        data-name="Path 1314"
        d="M10.608,3.131h-.34V1.821A1.823,1.823,0,0,0,8.448,0H3.981A1.823,1.823,0,0,0,2.161,1.821V3.131h-.34A1.823,1.823,0,0,0,0,4.952V7.865A1.823,1.823,0,0,0,1.821,9.686h.34v1.651a1.094,1.094,0,0,0,1.092,1.092H9.176a1.094,1.094,0,0,0,1.092-1.092V9.686h.34a1.823,1.823,0,0,0,1.821-1.821V4.952A1.823,1.823,0,0,0,10.608,3.131ZM2.889,1.821A1.094,1.094,0,0,1,3.981.728H8.448A1.094,1.094,0,0,1,9.54,1.821V3.131H2.889ZM9.54,11.336a.365.365,0,0,1-.364.364H3.253a.365.365,0,0,1-.364-.364V7.744H9.54ZM11.7,7.865a1.094,1.094,0,0,1-1.092,1.092h-.34V7.744h.218a.364.364,0,1,0,0-.728H1.942a.364.364,0,1,0,0,.728h.218V8.957h-.34A1.094,1.094,0,0,1,.728,7.865V4.952A1.094,1.094,0,0,1,1.821,3.86h8.788A1.094,1.094,0,0,1,11.7,4.952Z"
        transform="translate(-0.001)"
        fill="#5a5656"
      />
      <path
        id="Path_1315"
        data-name="Path 1315"
        d="M203.306,353h-1.942a.364.364,0,1,0,0,.728h1.942a.364.364,0,1,0,0-.728Z"
        transform="translate(-196.121 -344.431)"
        fill="#5a5656"
      />
      <path
        id="Path_1316"
        data-name="Path 1316"
        d="M203.306,417h-1.942a.364.364,0,1,0,0,.728h1.942a.364.364,0,1,0,0-.728Z"
        transform="translate(-196.121 -406.877)"
        fill="#5a5656"
      />
      <path
        id="Path_1317"
        data-name="Path 1317"
        d="M66.529,193H65.364a.364.364,0,0,0,0,.728h1.165a.364.364,0,0,0,0-.728Z"
        transform="translate(-63.423 -188.315)"
        fill="#5a5656"
      />
    </g>
  </SvgIcon>
);

export const BackRightArrowIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 28.46 18.573">
    <g id="Right_Arrow" data-name="Right Arrow" transform="translate(0.5 0.56)">
      <g id="Group_9" data-name="Group 9">
        <path
          id="Path_27"
          data-name="Path 27"
          d="M.168,93.7l8.581-8.209a.59.59,0,0,1,.809,0,.53.53,0,0,1,0,.774l-7.6,7.275H26.887a.548.548,0,1,1,0,1.095H1.953l7.6,7.275a.53.53,0,0,1,0,.774.59.59,0,0,1-.809,0L.168,94.476A.53.53,0,0,1,.168,93.7Z"
          transform="translate(0 -85.333)"
          fill="#149fcb"
          stroke="#149fcb"
          strokeWidth="1"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BackLeftArrowIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 28.46 18.573">
    <g
      id="Right_Arrow"
      data-name="Right Arrow"
      transform="translate(8.5 -9.44)"
    >
      <g id="Group_9" data-name="Group 9" transform="translate(-8 10)">
        <path
          id="Path_27"
          data-name="Path 27"
          d="M27.292,93.7l-8.581-8.209a.59.59,0,0,0-.809,0,.53.53,0,0,0,0,.774l7.6,7.275H.572a.548.548,0,1,0,0,1.095H25.507l-7.6,7.275a.53.53,0,0,0,0,.774.59.59,0,0,0,.809,0l8.581-8.209A.53.53,0,0,0,27.292,93.7Z"
          transform="translate(0 -85.333)"
          fill="#149fcb"
          stroke="#149fcb"
          strokeWidth="1"
        />
      </g>
    </g>
  </SvgIcon>
);

export const PlusIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 19.74 19.74">
    <g id="Group_23" data-name="Group 23" transform="translate(-1584 -940.5)">
      <line
        id="Line_13"
        data-name="Line 13"
        y2="19.74"
        transform="translate(1593.87 940.5)"
        fill="none"
        stroke="#149fcb"
        strokeWidth="3"
      />
      <path
        id="Path_33"
        data-name="Path 33"
        d="M0,0V19.74"
        transform="translate(1603.74 950.37) rotate(90)"
        fill="none"
        stroke="#149fcb"
        strokeWidth="3"
      />
    </g>
  </SvgIcon>
);

export const MPesaIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 101.726 51.005">
    <g id="Group_27" data-name="Group 27">
      <path
        id="Path_45"
        data-name="Path 45"
        d="M1080.067,815.52h7.811a4.53,4.53,0,0,1,4.517,4.517v12.987a4.53,4.53,0,0,1-4.517,4.517h-7.811a4.53,4.53,0,0,1-4.517-4.517V820.037a4.53,4.53,0,0,1,4.517-4.517Z"
        transform="translate(-1051.131 -805.921)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        id="Path_46"
        data-name="Path 46"
        d="M1017.877,485.53H1004.42a3.587,3.587,0,0,1-3.576-3.576v-39.43a3.586,3.586,0,0,1,3.576-3.576h13.457a3.564,3.564,0,0,1,.471.031v-2.9a1.557,1.557,0,0,1,1.553-1.553h0a1.557,1.557,0,0,1,1.553,1.553v4.893a1.537,1.537,0,0,1-.127.612,3.55,3.55,0,0,1,.127.941v39.43a3.587,3.587,0,0,1-3.576,3.576Zm-10.634-41.406h7.811a4.53,4.53,0,0,1,4.517,4.517v12.987a4.53,4.53,0,0,1-4.517,4.517h-7.811a4.531,4.531,0,0,1-4.517-4.517V448.641a4.531,4.531,0,0,1,4.517-4.517Z"
        transform="translate(-978.307 -434.525)"
        fill="#CDCDCD"
        fillRule="evenodd"
      />
      <path
        id="Path_47"
        data-name="Path 47"
        d="M1944.408,847.046l8.588-.033c3.131.4,4.578,2.741,4.446,6.15-.238,3.436-2.187,5.116-5.44,5.41l-3.118-.062.088,9.426h-4.564V847.046Zm4.612,2.143c2.12-.3,3.748.285,3.859,3.623-.071,2.98-1.654,3.734-3.859,3.576v-7.2Z"
        transform="translate(-1898.099 -836.621)"
        fill="#9C9C9C"
        fillRule="evenodd"
      />
      <path
        id="Path_48"
        data-name="Path 48"
        d="M2575.311,837.089l5.437-.025-.041,2.333-4.259-.019c-2.457.456-1.907,3.078-2.026,4.972l5.729-.107.02,2.864-5.551-.059-.027,6.936a2.785,2.785,0,0,0,2.762,2.807l3.049-.034.93.02-.029,2.165-.952.036-5.8-.062c-2-.068-3.61-1.058-4.352-4.137l-.142-13.456c.082-2.759,1.9-4.112,5.247-4.236Z"
        transform="translate(-2507.992 -826.923)"
        fill="#9C9C9C"
        fillRule="evenodd"
      />
      <path
        id="Path_49"
        data-name="Path 49"
        d="M3057.318,844.123c-.343-4.507,2.169-5.526,5.224-5.881,3.574-.212,5.819,1.279,6.257,5.083l-4.22-.011c-.268-1.919-1.76-2.656-3.126-1.743-1.947,2.382,4.129,6.573,5.95,8.127,3.148,2.49,2.615,9.392-2.234,10.672l-2.957.105c-3,.071-4.792-1.827-5.309-5.344l4.252-.075c.231,1.5.872,2.436,2.233,2.369,2.117-.4,2.7-2.266,1.194-4.644-3.152-2.677-6.885-5.188-7.264-8.657Z"
        transform="translate(-2982.567 -828.051)"
        fill="#9C9C9C"
        fillRule="evenodd"
      />
      <path
        id="Path_50"
        data-name="Path 50"
        d="M106.295,810.986h4.469l.047,1.388c2.7-1.167,4.737-1.992,6.871-.071,3.814-1.8,6.7-1.6,8.129,1.747l.2,18.768H121.5v-17.9c-.334-1.533-1.547-1.794-3.011-1.694v19.6h-4.611v-17.9c-.334-1.533-1.547-1.794-3.011-1.694v19.6h-4.575V810.986Z"
        transform="translate(-106.295 -801.502)"
        fill="#9C9C9C"
        fillRule="evenodd"
      />
      <path
        id="Path_51"
        data-name="Path 51"
        d="M3628.579,850.943h4.635V839.415h3.858v11.528h4.493V834.475c-.09-3.347-2.662-5.444-6.3-5.458-4.156-.037-6.525,1.934-6.682,5.27v16.656Zm4.635-17.644c.153-1.231.553-1.726,1.906-1.859,1.371.035,1.859.827,1.953,2.047v3.341h-3.858V833.3Z"
        transform="translate(-3539.84 -819.078)"
        fill="#9C9C9C"
        fillRule="evenodd"
      />
      <path
        id="Path_52"
        data-name="Path 52"
        d="M934.4,1164.289c.773,1.808,1.825,2.639,3.1,2.689a17.882,17.882,0,0,1-6.379,2.963,20.291,20.291,0,0,1-4.06-.806,10.5,10.5,0,0,0,7.34-4.846Z"
        transform="translate(-906.383 -1145.903)"
        fill="#000"
        stroke="#9C9C9C"
        strokeMiterlimit="2.613"
        strokeWidth="1.716"
        fillRule="evenodd"
      />
      <path
        id="Path_53"
        data-name="Path 53"
        d="M1099.629,979.39l9.316,4.705c-4.745,6.243-12.746,6.407-21.268,5.6a16.786,16.786,0,0,0,11.951-10.3Z"
        transform="translate(-1062.953 -965.663)"
        fill="#000"
        stroke="#9C9C9C"
        strokeMiterlimit="2.613"
        strokeWidth="1.716"
        fillRule="evenodd"
      />
    </g>
  </SvgIcon>
);

export const InfoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 16.5 16.5">
    <g
      id="Group_193"
      data-name="Group 193"
      transform="translate(-2574.546 -314.204)"
      opacity="0.813"
    >
      <path
        id="Path_463"
        data-name="Path 463"
        d="M2582.8,330.7a8.25,8.25,0,1,1,5.834-2.416A8.2,8.2,0,0,1,2582.8,330.7Zm0-15.318a7.068,7.068,0,1,0,7.068,7.068A7.076,7.076,0,0,0,2582.8,315.386Z"
        fill="#149fcb"
      />
      <g
        id="Group_187"
        data-name="Group 187"
        transform="translate(2580.948 319.454)"
      >
        <g id="Group_186" data-name="Group 186" transform="translate(0 0)">
          <path
            id="Path_464"
            data-name="Path 464"
            d="M2814.169,459.559a.765.765,0,0,0,.554-.23.787.787,0,0,0,0-1.112.78.78,0,0,0-.554-.222.74.74,0,0,0-.549.23.754.754,0,0,0-.23.554.74.74,0,0,0,.23.549A.749.749,0,0,0,2814.169,459.559Z"
            transform="translate(-2812.858 -457.996)"
            fill="#5c5454"
          />
          <path
            id="Path_465"
            data-name="Path 465"
            d="M2794.085,542.831h-.516s-.251,0-.26-.229c-.025-.307-.045-.559-.047-.632l-.03-.75c0-.045,0-.1,0-.179,0-.165,0-.294,0-.388q0-.051,0-.115l.013-.319v-.75a7.582,7.582,0,0,1-1.964.664l-.115.532a1.6,1.6,0,0,0,.307.03,1.013,1.013,0,0,0,.383-.072l.017,1.069c0,.262.007.594.014.926a.2.2,0,0,1-.21.212h-.561v1.147h2.981Z"
            transform="translate(-2791.104 -537.528)"
            fill="#5c5454"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ShoppingCartOutlinedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 22.347 21.756">
    <g id="ShoppingCart" transform="translate(0.25 0.25)">
      <path
        d="M98.933,350.322a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,98.933,350.322Zm0,3.547A1.267,1.267,0,1,1,100.2,352.6,1.267,1.267,0,0,1,98.933,353.869Z"
        transform="translate(-91.966 -333.626)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.5"
      />
      <path
        d="M297.464,350.322a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,297.464,350.322Zm0,3.547a1.267,1.267,0,1,1,1.267-1.267A1.267,1.267,0,0,1,297.464,353.869Z"
        transform="translate(-280.869 -333.626)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.5"
      />
      <path
        d="M21.738,9.423a.634.634,0,0,0-.405-.2L4.839,8.992,4.383,7.6A2.331,2.331,0,0,0,2.2,6.028H.507a.507.507,0,0,0,0,1.013H2.2a1.318,1.318,0,0,1,1.216.887l3.218,9.7-.253.583a2.432,2.432,0,0,0,.228,2.2,2.356,2.356,0,0,0,1.9,1.064h9.855a.507.507,0,1,0,0-1.013H8.513a1.292,1.292,0,0,1-1.064-.608,1.393,1.393,0,0,1-.127-1.216l.2-.456,10.666-1.115A2.787,2.787,0,0,0,20.6,14.946l1.216-5.092A.431.431,0,0,0,21.738,9.423Zm-2.128,5.3a1.723,1.723,0,0,1-1.545,1.343L7.525,17.15,5.168,10.006l15.531.228Z"
        transform="translate(0 -6.028)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.5"
      />
    </g>
  </SvgIcon>
);

export const ShoppingCartIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 21.841 21.256">
    <g id="Group_31" data-name="Group 31" transform="translate(0 0)">
      <g id="Group_30" data-name="Group 30" transform="translate(0 0)">
        <path
          id="Path_63"
          data-name="Path 63"
          d="M98.933,350.322a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,98.933,350.322Zm0,3.547A1.267,1.267,0,1,1,100.2,352.6,1.267,1.267,0,0,1,98.933,353.869Z"
          transform="translate(-91.966 -333.626)"
          fill="#5a5656"
        />
        <path
          id="Path_64"
          data-name="Path 64"
          d="M297.464,350.322a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,297.464,350.322Zm0,3.547a1.267,1.267,0,1,1,1.267-1.267A1.267,1.267,0,0,1,297.464,353.869Z"
          transform="translate(-280.869 -333.626)"
          fill="#5a5656"
        />
        <path
          id="Path_65"
          data-name="Path 65"
          d="M21.738,9.423a.634.634,0,0,0-.405-.2L4.839,8.992,4.383,7.6A2.331,2.331,0,0,0,2.2,6.028H.507a.507.507,0,0,0,0,1.013H2.2a1.318,1.318,0,0,1,1.216.887l3.218,9.7-.253.583a2.432,2.432,0,0,0,.228,2.2,2.356,2.356,0,0,0,1.9,1.064h9.855a.507.507,0,1,0,0-1.013H8.513a1.292,1.292,0,0,1-1.064-.608,1.393,1.393,0,0,1-.127-1.216l.2-.456,10.666-1.115A2.787,2.787,0,0,0,20.6,14.946l1.216-5.092A.431.431,0,0,0,21.738,9.423Zm-2.128,5.3a1.723,1.723,0,0,1-1.545,1.343L7.525,17.15,5.168,10.006l15.531.228Z"
          transform="translate(0 -6.028)"
          fill="#5a5656"
        />
      </g>
    </g>
  </SvgIcon>
);

export const TrackIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 18.708 13.1">
    <g id="Group_221" data-name="Group 221" transform="translate(13.72 9.979)">
      <g id="Group_220" data-name="Group 220" transform="translate(0 0)">
        <path
          id="Path_1290"
          data-name="Path 1290"
          d="M80.935,327.978a.935.935,0,1,1-.935.935A.935.935,0,0,1,80.935,327.978Zm0,1.247a.312.312,0,1,0-.312-.312A.312.312,0,0,0,80.935,329.225Z"
          transform="translate(-80 -327.978)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_223" data-name="Group 223" transform="translate(3.118 9.979)">
      <g id="Group_222" data-name="Group 222" transform="translate(0 0)">
        <path
          id="Path_1291"
          data-name="Path 1291"
          d="M352.935,327.978a.935.935,0,1,1-.935.935A.935.935,0,0,1,352.935,327.978Zm0,1.247a.312.312,0,1,0-.312-.312A.312.312,0,0,0,352.935,329.225Z"
          transform="translate(-352 -327.978)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_225" data-name="Group 225" transform="translate(10.913 4.678)">
      <g id="Group_224" data-name="Group 224" transform="translate(0 0)">
        <path
          id="Path_1292"
          data-name="Path 1292"
          d="M120.31,191.978h1.559a.312.312,0,0,1,.279.172l.935,1.871a.312.312,0,0,1-.279.451H120.31a.312.312,0,0,1-.312-.312V192.29A.312.312,0,0,1,120.31,191.978Zm.312,1.871H122.3l-.624-1.247h-1.055Z"
          transform="translate(-119.998 -191.978)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_227" data-name="Group 227" transform="translate(0 0)">
      <g id="Group_226" data-name="Group 226" transform="translate(0 0)">
        <path
          id="Path_1293"
          data-name="Path 1293"
          d="M2.084,76.805a.921.921,0,0,1-.511,1.687H.921A.922.922,0,0,1,0,77.572v-.326H.624v.326a.3.3,0,0,0,.3.3h.652a.3.3,0,0,0,.165-.545l-.664-.443a.312.312,0,0,1-.139-.259V72.88a.947.947,0,0,1,1.677-.592L7.265,77.92l.97-1.94a.935.935,0,0,1,.184-1.852H10.29a.935.935,0,0,1,.935.935.925.925,0,0,1-.057.312h1.974a1.241,1.241,0,0,1,1.116.689l1.232,2.463,1.964.393a1.559,1.559,0,0,1,1.24,1.374.292.292,0,0,1,.015.069v2.494a.312.312,0,0,1-.312.312H16.813a2.18,2.18,0,0,1-4.315,0H7.172A.312.312,0,0,1,6.891,83l-.847-1.7H5.578a2.183,2.183,0,1,1-3.087.038l.038-.038H2.064L1.214,83a.312.312,0,0,1-.279.172H.312A.312.312,0,0,1,0,82.858v-3.43a.312.312,0,0,1,.312-.312h4.7L1.559,74.181v2.274Zm5.28,2.311H8.506L9.545,76H8.923Zm1.8,0h.5V77.608Zm8.922,1.559H16.838V81.3h1.247ZM16.66,82c.01.022.017.046.027.069.016.041.031.081.045.123s.016.054.023.08.022.079.031.119.011.058.017.087.01.047.014.072h1.269v-.624h-1.46C16.637,81.947,16.649,81.972,16.66,82Zm-2,2.42A1.559,1.559,0,1,0,13.1,82.858,1.559,1.559,0,0,0,14.655,84.417ZM10.29,79.428v3.118h2.2c0-.024.009-.047.014-.071s.01-.059.017-.088.02-.08.031-.119.014-.054.023-.08.029-.082.045-.123c.009-.023.017-.046.027-.069.021-.047.044-.094.067-.139.007-.014.014-.029.021-.043q.049-.089.106-.174l.018-.025c.033-.046.066-.094.1-.136.014-.017.029-.033.043-.049.03-.034.06-.068.091-.1s.037-.035.055-.052.06-.057.094-.084l.062-.051c.031-.025.062-.049.1-.072l.07-.047.1-.062.075-.041c.035-.018.07-.035.107-.052l.079-.034c.037-.015.075-.029.113-.042l.081-.027c.04-.012.081-.022.122-.031l.08-.018c.046-.009.094-.015.139-.022l.069-.009c.07-.006.141-.01.213-.01s.143,0,.214.011l.069.009c.047.006.094.012.139.022l.079.018c.041.01.082.02.122.031l.081.027c.038.013.076.027.113.042l.079.034c.036.017.072.033.107.052l.075.041c.034.02.068.04.1.062l.07.046c.033.023.065.047.1.072s.042.033.062.051l.094.084c.018.017.037.034.055.052l0,0v-.969a.312.312,0,0,1,.312-.312h1.465a.935.935,0,0,0-.659-.519l-2.117-.423A.312.312,0,0,1,15,78.944l-1.3-2.6A.621.621,0,0,0,13.141,76H10.29Zm.312-4.365a.312.312,0,0,0-.312-.312H8.419a.312.312,0,1,0,0,.624H10.29A.312.312,0,0,0,10.6,75.063Zm-8.107,7.8A1.559,1.559,0,1,0,4.054,81.3,1.559,1.559,0,0,0,2.494,82.858ZM.624,79.74v2.806H.743l.847-1.7a.312.312,0,0,1,.281-.172H6.236a.312.312,0,0,1,.281.172l.847,1.7h2.3V79.74Zm.994-6.563,4.157,5.939h.892l.143-.286.15-.3L2.133,72.686a.324.324,0,0,0-.574.206v.1A.323.323,0,0,0,1.618,73.178Z"
          transform="translate(0 -71.944)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_229" data-name="Group 229" transform="translate(10.913 7.796)">
      <g id="Group_228" data-name="Group 228" transform="translate(0 0)">
        <rect
          id="Rectangle_48"
          data-name="Rectangle 48"
          width="1.247"
          height="0.624"
          fill="#5a5656"
        />
      </g>
    </g>
  </SvgIcon>
);

export const CarIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 17.099 14.34">
    <g id="Group_231" data-name="Group 231" transform="translate(0 4.033)">
      <g id="Group_230" data-name="Group 230" transform="translate(0 0)">
        <path
          id="Path_1294"
          data-name="Path 1294"
          d="M.471,142.15l2.395-2.234a1.458,1.458,0,0,1,1.015-.4h.588v-.627H3.923a.392.392,0,0,1,0-.784H9.206a.392.392,0,0,1,0,.784H8.661v.627h.56a1.5,1.5,0,0,1,1.09.466l2.026,2.159a0,0,0,0,1,0,0l2.673-2.1a.054.054,0,0,1,.016-.012,1.268,1.268,0,0,1,1.575.078l.357.314a.392.392,0,0,1-.509.6l-.008-.008-.357-.314a.489.489,0,0,0-.6-.027l-2.159,1.7h1.34a2.215,2.215,0,0,1,2.222,2.206v.89a1.485,1.485,0,0,1-1.485,1.489h-.251a1.969,1.969,0,0,1-3.8,0H5.507a1.969,1.969,0,0,1-3.8,0H1.482A1.481,1.481,0,0,1,0,145.481v-2.242A1.491,1.491,0,0,1,.471,142.15ZM3.88,140.3a.7.7,0,0,0-.486.192l-2.018,1.885H3.782l.964-2.077Zm.768,2.077H7.055V140.3H5.612Zm3.229-3.488H5.252v.627H7.878Zm5.381,8.74a1.184,1.184,0,1,0-1.184-1.184A1.183,1.183,0,0,0,13.258,147.633Zm-5.42-1.45h3.468a1.97,1.97,0,0,1,3.9,0h.2a.7.7,0,0,0,.7-.705V144.6a1.43,1.43,0,0,0-1.427-1.43H12.855a.661.661,0,0,1-.086,0c-.016,0-.027,0-.043,0H7.838Zm0-3.8h3.637l-1.736-1.854a.715.715,0,0,0-.517-.223H7.838ZM3.61,147.633a1.184,1.184,0,1,0-1.184-1.184A1.183,1.183,0,0,0,3.61,147.633ZM.784,143.239v2.238a.7.7,0,0,0,.694.705h.184a1.991,1.991,0,0,1,1.952-1.7,1.991,1.991,0,0,1,1.952,1.7H7.055v-3.018H.78A.693.693,0,0,0,.784,143.239Z"
          transform="translate(0 -138.109)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_233" data-name="Group 233" transform="translate(13.493 0)">
      <g id="Group_232" data-name="Group 232" transform="translate(0 0)">
        <path
          id="Path_1295"
          data-name="Path 1295"
          d="M63.506,37.67a1.234,1.234,0,0,1,.227-.729.475.475,0,0,0,.106-.306.448.448,0,0,0-.106-.306,1.207,1.207,0,0,1-.227-.729.392.392,0,1,1,.784,0,.441.441,0,0,0,.106.306,1.207,1.207,0,0,1,.227.729,1.234,1.234,0,0,1-.227.729.475.475,0,0,0-.106.306.465.465,0,0,0,.106.31,1.283,1.283,0,0,1,0,1.458.478.478,0,0,0-.106.31.392.392,0,1,1-.784,0,1.234,1.234,0,0,1,.227-.729.478.478,0,0,0,.106-.31.458.458,0,0,0-.106-.31A1.207,1.207,0,0,1,63.506,37.67Z"
          transform="translate(-63.506 -35.209)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_235" data-name="Group 235" transform="translate(11.985 1.035)">
      <g id="Group_234" data-name="Group 234" transform="translate(0 0)">
        <path
          id="Path_1296"
          data-name="Path 1296"
          d="M102.339,64.074a.458.458,0,0,0-.106-.31,1.207,1.207,0,0,1-.227-.729,1.234,1.234,0,0,1,.227-.729.475.475,0,0,0,.106-.306.392.392,0,1,1,.784,0,1.234,1.234,0,0,1-.227.729.475.475,0,0,0-.106.306.465.465,0,0,0,.106.31,1.283,1.283,0,0,1,0,1.458.478.478,0,0,0-.106.31.392.392,0,1,1-.784,0,1.234,1.234,0,0,1,.227-.729A.478.478,0,0,0,102.339,64.074Z"
          transform="translate(-102.006 -61.609)"
          fill="#5a5656"
        />
      </g>
    </g>
    <g id="Group_237" data-name="Group 237" transform="translate(15.002 1.035)">
      <g id="Group_236" data-name="Group 236" transform="translate(0 0)">
        <path
          id="Path_1297"
          data-name="Path 1297"
          d="M25.339,64.074a.458.458,0,0,0-.106-.31,1.207,1.207,0,0,1-.227-.729,1.234,1.234,0,0,1,.227-.729A.475.475,0,0,0,25.339,62a.392.392,0,1,1,.784,0,1.234,1.234,0,0,1-.227.729.475.475,0,0,0-.106.306.465.465,0,0,0,.106.31,1.283,1.283,0,0,1,0,1.458.478.478,0,0,0-.106.31.392.392,0,1,1-.784,0,1.234,1.234,0,0,1,.227-.729A.478.478,0,0,0,25.339,64.074Z"
          transform="translate(-25.006 -61.609)"
          fill="#5a5656"
        />
      </g>
    </g>
  </SvgIcon>
);

export const WindScreenIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 16.823 11.215">
    <g id="windscreen" transform="translate(0 -85.333)">
      <g id="Group_215" data-name="Group 215" transform="translate(0 85.333)">
        <g id="Group_214" data-name="Group 214" transform="translate(0)">
          <path
            id="Path_1278"
            data-name="Path 1278"
            d="M16.736,88.257c-.1-.119-2.624-2.924-8.325-2.924s-8.22,2.8-8.325,2.924a.35.35,0,0,0-.074.323l2.1,7.711a.352.352,0,0,0,.551.186c.017-.013,1.794-1.33,5.745-1.33.395,0,.761.016,1.113.04l-.425.661H8.94a.35.35,0,1,0,0,.7h1.4a.35.35,0,1,0,0-.7h-.41l.379-.59a8.552,8.552,0,0,1,3.845,1.218.354.354,0,0,0,.213.072.339.339,0,0,0,.112-.019.35.35,0,0,0,.226-.239l2.1-7.711A.35.35,0,0,0,16.736,88.257Zm-2.581,7.395a10.149,10.149,0,0,0-3.426-1.044l1.907-2.966h.637L12.6,94.1a.35.35,0,0,0,.246.43.344.344,0,0,0,.092.012.35.35,0,0,0,.338-.258l1.429-5.239a.35.35,0,1,0-.676-.184l-.567,2.08H12.445a.35.35,0,0,0-.295.161l-2.2,3.419c-.478-.043-.982-.075-1.541-.075a11.915,11.915,0,0,0-5.744,1.206L.741,88.589c.559-.536,2.975-2.555,7.67-2.555,4.675,0,7.108,2.02,7.67,2.556Z"
            transform="translate(0 -85.333)"
            fill="#5a5656"
          />
        </g>
      </g>
      <g
        id="Group_217"
        data-name="Group 217"
        transform="translate(2.102 88.137)"
      >
        <g id="Group_216" data-name="Group 216">
          <path
            id="Path_1279"
            data-name="Path 1279"
            d="M65.2,170.712a.351.351,0,0,0-.47.157l-.7,1.4a.351.351,0,0,0,.627.314l.7-1.4A.35.35,0,0,0,65.2,170.712Z"
            transform="translate(-63.995 -170.676)"
            fill="#5a5656"
          />
        </g>
      </g>
      <g
        id="Group_219"
        data-name="Group 219"
        transform="translate(2.803 88.137)"
      >
        <g id="Group_218" data-name="Group 218">
          <path
            id="Path_1280"
            data-name="Path 1280"
            d="M87.237,170.712a.351.351,0,0,0-.47.157l-1.4,2.8a.351.351,0,0,0,.627.314l1.4-2.8A.35.35,0,0,0,87.237,170.712Z"
            transform="translate(-85.328 -170.676)"
            fill="#5a5656"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const RadioIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 14.253 13.799">
    <g id="radio" transform="translate(0.1 -8.182)">
      <path
        id="Path_1281"
        data-name="Path 1281"
        d="M36.294,215.367a3.165,3.165,0,0,0-3.162,3.162,3.133,3.133,0,0,0,.645,1.914.206.206,0,1,0,.328-.249,2.725,2.725,0,0,1-.561-1.665,2.749,2.749,0,1,1,1.105,2.2.206.206,0,1,0-.246.33,3.162,3.162,0,1,0,1.891-5.7Z"
        transform="translate(-32.223 -201.401)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1282"
        data-name="Path 1282"
        d="M102.084,282.977a1.343,1.343,0,1,0-1.343,1.343A1.344,1.344,0,0,0,102.084,282.977Zm-2.274,0a.931.931,0,1,1,.931.931A.932.932,0,0,1,99.811,282.977Z"
        transform="translate(-96.671 -265.849)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1283"
        data-name="Path 1283"
        d="M13.847,15.146a.206.206,0,0,0,.206-.206V13.49a1.117,1.117,0,0,0-1.115-1.115h-.249V11.89a.426.426,0,0,0-.425-.425h-1.38a.426.426,0,0,0-.425.425v.484h-.5V11.89a.426.426,0,0,0-.425-.425H8.156a.426.426,0,0,0-.425.425v.484H3.595v-.421L11.05,9.344a.66.66,0,1,0-.137-.4s0,.009,0,.013L3.447,11.569a.423.423,0,0,0-.278-.1H1.79a.426.426,0,0,0-.425.425v.484H1.115A1.117,1.117,0,0,0,0,13.49v7.276a1.117,1.117,0,0,0,1.115,1.115H12.938a1.117,1.117,0,0,0,1.115-1.115v-5a.206.206,0,1,0-.412,0v5a.7.7,0,0,1-.7.7h-4.8V12.786h4.8a.7.7,0,0,1,.7.7v1.45a.206.206,0,0,0,.206.206ZM11.574,8.694a.249.249,0,1,1-.249.249A.249.249,0,0,1,11.574,8.694Zm-9.8,3.2a.014.014,0,0,1,.014-.014h1.38a.013.013,0,0,1,.008,0h0l.005.011v.482H1.776Zm-.661,9.578a.7.7,0,0,1-.7-.7V13.49a.7.7,0,0,1,.7-.7H7.73v8.683Zm7.027-9.094V11.89a.014.014,0,0,1,.014-.014h1.38a.014.014,0,0,1,.014.014v.484Zm2.728,0V11.89a.014.014,0,0,1,.014-.014h1.38a.014.014,0,0,1,.014.014v.484Z"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1284"
        data-name="Path 1284"
        d="M319.271,190.941a.426.426,0,0,0-.425-.425h-3.653a.426.426,0,0,0-.425.425v.925a.426.426,0,0,0,.425.425h3.653a.426.426,0,0,0,.425-.425Zm-.412.925a.014.014,0,0,1-.014.014h-3.653a.014.014,0,0,1-.014-.014v-.925a.014.014,0,0,1,.014-.014h3.653a.014.014,0,0,1,.014.014Z"
        transform="translate(-306.127 -177.232)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1285"
        data-name="Path 1285"
        d="M315.655,275.125a.888.888,0,1,0-.888-.888A.889.889,0,0,0,315.655,275.125Zm0-1.364a.476.476,0,1,1-.476.476A.477.477,0,0,1,315.655,273.761Z"
        transform="translate(-306.127 -257.791)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1286"
        data-name="Path 1286"
        d="M415.056,273.35a.888.888,0,1,0,.888.888A.889.889,0,0,0,415.056,273.35Zm0,1.364a.476.476,0,1,1,.476-.476A.477.477,0,0,1,415.056,274.714Z"
        transform="translate(-402.8 -257.793)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1287"
        data-name="Path 1287"
        d="M319.065,356.184h-4.092a.206.206,0,0,0,0,.412h4.092a.206.206,0,0,0,0-.412Z"
        transform="translate(-306.127 -338.353)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1288"
        data-name="Path 1288"
        d="M319.065,389.316h-4.092a.206.206,0,1,0,0,.412h4.092a.206.206,0,1,0,0-.412Z"
        transform="translate(-306.127 -370.576)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
      <path
        id="Path_1289"
        data-name="Path 1289"
        d="M319.065,422.45h-4.092a.206.206,0,0,0,0,.412h4.092a.206.206,0,0,0,0-.412Z"
        transform="translate(-306.127 -402.8)"
        fill="#5a5656"
        stroke="#5a5656"
        strokeWidth="0.2"
      />
    </g>
  </SvgIcon>
);

export const SideMirrorIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 17.118 10.491">
    <g id="side-mirror" transform="translate(-1 -13)">
      <path
        id="Path_1298"
        data-name="Path 1298"
        d="M17.289,14.657a1.383,1.383,0,0,0-1.353,1.1H14.791a3.018,3.018,0,0,0-3.645-2.693L3.382,14.747A3.037,3.037,0,0,0,1,17.7v2.773a3.023,3.023,0,0,0,3.02,3.02h7.765a3.022,3.022,0,0,0,3.007-2.761h1.145a1.383,1.383,0,0,0,1.353,1.1h.828V14.657Zm-1.38,1.657v3.865H14.8V16.313Zm-1.657,4.158a2.471,2.471,0,0,1-2.468,2.468H4.02a2.471,2.471,0,0,1-2.468-2.468V17.7A2.481,2.481,0,0,1,3.5,15.287l7.765-1.679a2.467,2.467,0,0,1,2.989,2.412Zm3.313.811h-.276a.829.829,0,0,1-.828-.828V16.037a.829.829,0,0,1,.828-.828h.276Z"
        fill="#5a5656"
      />
      <path
        id="Path_1299"
        data-name="Path 1299"
        d="M14.68,17a1.911,1.911,0,0,0-.4.043L6.511,18.722A1.926,1.926,0,0,0,5,20.594v2.773a1.918,1.918,0,0,0,1.915,1.915H14.68A1.917,1.917,0,0,0,16.6,23.367V18.915A1.918,1.918,0,0,0,14.68,17ZM5.552,23.367v-2.5H9.085L8.36,24.73H6.915a1.365,1.365,0,0,1-1.363-1.363Zm5.522-1.4v-1.1h.875l.725,3.865H8.922l.725-3.865h.875v1.1ZM13.559,18.7l.828.473v1.141H12.73V19.172ZM14.68,24.73H13.236l-.725-3.865h3.533v2.5A1.365,1.365,0,0,1,14.68,24.73Zm1.363-4.417h-1.1v-.826l.415.237.274-.479-2.07-1.183-2.07,1.183.274.479.415-.237v.826H5.585a1.37,1.37,0,0,1,1.042-1.051l7.765-1.679a1.364,1.364,0,0,1,1.651,1.333Z"
        transform="translate(-2.896 -2.896)"
        fill="#5a5656"
      />
      <path
        id="Path_1300"
        data-name="Path 1300"
        d="M25,39h.552v1.1H25Z"
        transform="translate(-17.374 -18.822)"
        fill="#5a5656"
      />
    </g>
  </SvgIcon>
);

export const BillIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12.246 12.454">
    <g
      id="reciept-bill-covid19-coronavirus-healthcare"
      transform="translate(-1.999 -2)"
    >
      <path
        id="Path_1301"
        data-name="Path 1301"
        d="M13.207,2H4.9A1.038,1.038,0,0,0,3.867,3.038V9.275a2.076,2.076,0,0,0,0,4.13v.425A.21.21,0,0,0,3.95,14l.554.415a.205.205,0,0,0,.249,0l.428-.322.428.322a.205.205,0,0,0,.249,0l.43-.322.428.322a.205.205,0,0,0,.249,0l.43-.322.428.322a.205.205,0,0,0,.249,0l.43-.322.428.322a.205.205,0,0,0,.249,0l.43-.322.43.322a.205.205,0,0,0,.249,0l.428-.322.43.322a.205.205,0,0,0,.249,0l.432-.322.43.322a.214.214,0,0,0,.125.042.188.188,0,0,0,.093-.023.205.205,0,0,0,.114-.185V6.566h1.453a.208.208,0,0,0,.208-.208V3.038A1.038,1.038,0,0,0,13.207,2ZM2.414,11.34A1.66,1.66,0,1,1,4.075,13,1.66,1.66,0,0,1,2.414,11.34Zm9.755-8.3V13.83l-.222-.166a.205.205,0,0,0-.249,0l-.432.322-.43-.322a.205.205,0,0,0-.249,0l-.428.322-.43-.322a.205.205,0,0,0-.249,0l-.43.322-.428-.322a.205.205,0,0,0-.249,0l-.43.322-.428-.322a.205.205,0,0,0-.249,0l-.43.322-.428-.322a.205.205,0,0,0-.249,0l-.43.322-.428-.322a.205.205,0,0,0-.249,0l-.428.322-.347-.259V13.4a2.076,2.076,0,0,0,0-4.13V3.038A.625.625,0,0,1,4.9,2.415h7.478A1.022,1.022,0,0,0,12.169,3.038Zm1.66,3.113H12.584V3.038a.623.623,0,0,1,1.245,0Z"
        fill="#5a5656"
      />
      <path
        id="Path_1302"
        data-name="Path 1302"
        d="M28.283,6.623h-.415V6.208A.208.208,0,0,0,27.66,6h-.83a.208.208,0,0,0-.208.208v.415h-.415A.208.208,0,0,0,26,6.83v.83a.208.208,0,0,0,.208.208h.415v.415a.208.208,0,0,0,.208.208h.83a.208.208,0,0,0,.208-.208V7.868h.415a.208.208,0,0,0,.208-.208V6.83A.208.208,0,0,0,28.283,6.623Zm-.208.83H27.66a.208.208,0,0,0-.208.208v.415h-.415V7.66a.208.208,0,0,0-.208-.208h-.415V7.038h.415a.208.208,0,0,0,.208-.208V6.415h.415V6.83a.208.208,0,0,0,.208.208h.415Z"
        transform="translate(-19.02 -3.17)"
        fill="#5a5656"
      />
      <path
        id="Path_1303"
        data-name="Path 1303"
        d="M23.019,20H17.208a.208.208,0,0,0-.208.208v3.321a.208.208,0,0,0,.208.208h5.811a.208.208,0,0,0,.208-.208V20.208A.208.208,0,0,0,23.019,20ZM17.83,23.321h-.415V21.245h.415Zm0-2.491h-.415v-.415h.415Zm4.981,2.491H18.245V21.245h4.566Zm0-2.491H18.245v-.415h4.566Z"
        transform="translate(-11.888 -14.264)"
        fill="#5a5656"
      />
      <path
        id="Path_1304"
        data-name="Path 1304"
        d="M9.038,42.7V42.47a.677.677,0,0,0,.623-.6c0-.349-.365-.623-.83-.623-.253,0-.415-.123-.415-.208s.162-.208.415-.208.415.123.415.208a.208.208,0,0,0,.415,0,.678.678,0,0,0-.623-.6v-.228a.208.208,0,0,0-.415,0v.228a.677.677,0,0,0-.623.6c0,.349.365.623.83.623.253,0,.415.123.415.208s-.162.208-.415.208-.415-.123-.415-.208a.208.208,0,1,0-.415,0,.678.678,0,0,0,.623.6V42.7a.208.208,0,1,0,.415,0Z"
        transform="translate(-4.756 -30.113)"
        fill="#5a5656"
      />
      <path
        id="Path_1305"
        data-name="Path 1305"
        d="M32.528,42H29.208a.208.208,0,1,0,0,.415h3.321a.208.208,0,0,0,0-.415Z"
        transform="translate(-21.397 -31.698)"
        fill="#5a5656"
      />
      <path
        id="Path_1306"
        data-name="Path 1306"
        d="M32.528,46H29.208a.208.208,0,1,0,0,.415h3.321a.208.208,0,0,0,0-.415Z"
        transform="translate(-21.397 -34.868)"
        fill="#5a5656"
      />
      <path
        id="Path_1307"
        data-name="Path 1307"
        d="M32.528,50H29.208a.208.208,0,1,0,0,.415h3.321a.208.208,0,0,0,0-.415Z"
        transform="translate(-21.397 -38.038)"
        fill="#5a5656"
      />
      <path
        id="Path_1308"
        data-name="Path 1308"
        d="M24.415,42h-.208a.208.208,0,1,0,0,.415h.208a.208.208,0,0,0,0-.415Z"
        transform="translate(-17.435 -31.698)"
        fill="#5a5656"
      />
      <path
        id="Path_1309"
        data-name="Path 1309"
        d="M24.415,46h-.208a.208.208,0,1,0,0,.415h.208a.208.208,0,0,0,0-.415Z"
        transform="translate(-17.435 -34.868)"
        fill="#5a5656"
      />
      <path
        id="Path_1310"
        data-name="Path 1310"
        d="M24.415,50h-.208a.208.208,0,1,0,0,.415h.208a.208.208,0,0,0,0-.415Z"
        transform="translate(-17.435 -38.038)"
        fill="#5a5656"
      />
    </g>
  </SvgIcon>
);

export const TppIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 15.437 15.437">
    <g id="tpp" transform="translate(-1 -1)">
      <path
        id="Path_1322"
        data-name="Path 1322"
        d="M16.437,8.469a.981.981,0,0,0-.418-.809,1.452,1.452,0,0,0,.169-.685,1.494,1.494,0,0,0-.635-1.223,1.743,1.743,0,1,0-2.4-2.333,1.461,1.461,0,0,0-.7-.179,1.494,1.494,0,0,0-1.058,2.54,1.245,1.245,0,0,0-.436.946v.032a1,1,0,0,0-.747.964,1.053,1.053,0,0,0,.035.249H8.718a.249.249,0,0,0-.192.09l-2.415,2.9H5.731A1.245,1.245,0,0,0,4.486,12.2V14.2a.249.249,0,0,0,.249.249H6.253a1.205,1.205,0,0,0,.224.5H4.61l-.642-.856L3.739,13.2l.249-.936a.249.249,0,0,0,0-.06V10.959a.249.249,0,0,0-.027-.112l-.184-.368.159-.249.112.132.378-.324L3.283,8.718H4.735a.249.249,0,0,0,.222-.137l.5-1.013.535,1.245a.249.249,0,0,0,.289.154l.655-.132-.662,1,.413.274,1-1.494a.247.247,0,0,0-.249-.381l-1.046.209L5.718,6.883a.249.249,0,0,0-.451-.015L4.58,8.22H4.237V1.249A.249.249,0,0,0,3.988,1H1.249v.5h2.49V8.22h-1a.249.249,0,0,0-.189.411L3.6,9.849l-.316.476a.249.249,0,0,0-.015.249l.222.446v1.155l-.249.966a.249.249,0,0,0,0,.12l.249,1a.249.249,0,0,0,.042.09l.456.6H1.249A.249.249,0,0,0,1,15.192v1a.249.249,0,0,0,.249.249H16.188a.249.249,0,0,0,.249-.249v-1a.249.249,0,0,0-.249-.249h-1a1.205,1.205,0,0,0,.232-.5h.764a.249.249,0,0,0,.249-.249v-2.49a.747.747,0,0,0-.747-.747h-.356l-.122-.214a1.494,1.494,0,0,0,.727-1.28,1.2,1.2,0,0,0,0-.132A1,1,0,0,0,16.437,8.469ZM5.731,11.457H5.98v.5a.249.249,0,0,1-.249.249H4.984A.747.747,0,0,1,5.731,11.457Zm1,2.739a.747.747,0,1,1,.747.747A.747.747,0,0,1,6.726,14.2Zm1.967.249h4.282a1.205,1.205,0,0,0,.224.5H8.469A1.205,1.205,0,0,0,8.693,14.445Zm7.245,1.494H1.5v-.5H15.939ZM13.449,14.2a.747.747,0,1,1,.747.747A.747.747,0,0,1,13.449,14.2Zm2.49-2.49v2.241h-.523a1.245,1.245,0,0,0-2.44,0H8.693a1.245,1.245,0,0,0-2.44,0H4.984V12.7h.747a.747.747,0,0,0,.747-.747v-.5H15.69A.249.249,0,0,1,15.939,11.706ZM13.3,10.959l-.528-.53.2-.3.523.834Zm-.983-.747H11.86l-.182-.361-.443.224.249.5a.249.249,0,0,0,.222.137h.645l.249.249H10.812l-.6-.6v-.4a.249.249,0,0,0-.072-.177l-.324-.321h2.739l.122.2ZM9.229,9.58l.383.383-.573.57.354.354.339-.339a.281.281,0,0,0,.055.09l.324.321H8.021Zm4.855,1.379-1.17-1.875a.249.249,0,0,0-.212-.117H9.216a.249.249,0,0,0-.187.085L7.361,10.959h-.6l2.074-2.49h4.482l1.452,2.49Zm1.494-2.017a.249.249,0,0,0-.172.3.961.961,0,0,1,.035.227,1,1,0,0,1-.481.851L13.663,8.1a.249.249,0,0,0-.214-.124H10.777a.5.5,0,0,1,.416-.747h.042a.234.234,0,0,0,.2-.092.249.249,0,0,0,.045-.219.807.807,0,0,1-.027-.187.747.747,0,0,1,.466-.69.248.248,0,0,0,.03-.446,1,1,0,0,1,.5-1.852.976.976,0,0,1,.65.249.249.249,0,0,0,.4-.117,1.245,1.245,0,1,1,1.19,1.611h-.027a.252.252,0,1,0,0,.5l.022,0A1,1,0,0,1,15.463,7.6a.249.249,0,0,0,.12.4.5.5,0,0,1,0,.946Z"
        fill="#5a5656"
      />
    </g>
  </SvgIcon>
);

export const InjuryIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 15.437 15.437">
    <g id="injury" transform="translate(-68.036 -96.52) rotate(50)">
      <path
        id="Path_1329"
        data-name="Path 1329"
        d="M134.551.735a.99.99,0,0,0-1.212-.7,11.773,11.773,0,0,1-1.6.312.33.33,0,1,0,.081.656,12.433,12.433,0,0,0,1.692-.33.33.33,0,1,1,.17.637,13.281,13.281,0,0,1-3.388.447,13.282,13.282,0,0,1-3.388-.447.33.33,0,0,1,.17-.637,12.436,12.436,0,0,0,1.692.33.33.33,0,1,0,.081-.656,11.777,11.777,0,0,1-1.6-.313.99.99,0,0,0-1.113,1.452.983.983,0,0,0,.6.461q.29.078.587.143v8.149a2.975,2.975,0,0,0,1.982,2.8v2.178l-.32,1.282a.33.33,0,0,0,.32.41h1.982a.33.33,0,0,0,.32-.41l-.32-1.282V13.041a2.975,2.975,0,0,0,1.982-2.8V2.09q.3-.065.586-.143a.99.99,0,0,0,.7-1.212Zm-3.269,1.644V5.945H129.3V2.379c.332.025.663.037.991.037S130.95,2.4,131.283,2.379ZM129.724,16.25l.165-.661h.805l.165.661Zm2.88-6.011a2.315,2.315,0,0,1-1.734,2.238.33.33,0,0,0-.247.32v2.132h-.661V12.8a.33.33,0,0,0-.247-.32,2.315,2.315,0,0,1-1.734-2.238V2.218q.329.056.661.1V6.276a.33.33,0,0,0,.33.33h2.642a.33.33,0,0,0,.33-.33V2.315q.331-.04.661-.1v8.02Z"
        fill="#5a5656"
      />
      <path
        id="Path_1330"
        data-name="Path 1330"
        d="M208.977,220.009h-2.642a.33.33,0,0,0-.33.33v2.642a1.651,1.651,0,1,0,3.3,0v-2.642A.33.33,0,0,0,208.977,220.009Zm-.33,2.972a.991.991,0,1,1-1.982,0V220.67h1.982Z"
        transform="translate(-77.365 -212.743)"
        fill="#5a5656"
      />
      <path
        id="Path_1331"
        data-name="Path 1331"
        d="M246.332,13.815a.33.33,0,0,0,0-.661h0a.33.33,0,0,0,0,.661Z"
        transform="translate(-116.041 -12.719)"
        fill="#5a5656"
      />
    </g>
  </SvgIcon>
);

export const TaxiTransportationIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 15.301 17.301">
    <g
      id="Passenger-Taxi-Transportation-Safety-Shield"
      transform="translate(22)"
    >
      <path
        id="Path_1323"
        data-name="Path 1323"
        d="M38.17,37.315a.767.767,0,0,0-.765-.765.752.752,0,0,0-.507.2l-.273-.543-.2-.8a.508.508,0,0,0-.495-.385h-.566v-.765A.255.255,0,0,0,35.109,34h-2.04a.255.255,0,0,0-.255.255v.765h-.566a.508.508,0,0,0-.495.385l-.2.8-.273.543a.752.752,0,0,0-.507-.2.765.765,0,0,0-.408,1.41.75.75,0,0,0-.1.375v2.3a.512.512,0,0,0,.51.51h1.02a.512.512,0,0,0,.51-.51v-.51h3.57v.51a.512.512,0,0,0,.51.51H37.4a.512.512,0,0,0,.51-.51v-2.3a.75.75,0,0,0-.1-.375A.761.761,0,0,0,38.17,37.315ZM33.324,34.51h1.53v.51h-1.53Zm-1.076,1.02H35.93l.128.51H32.12Zm-.3,1.02h4.274l.51,1.02H31.442Zm-1.433.765a.253.253,0,0,1,.5-.043l-.135.268a.238.238,0,0,1-.112.031A.255.255,0,0,1,30.519,37.315Zm1.275,3.315h-1.02v-.556a.765.765,0,0,0,.255.046h.765Zm5.61,0h-1.02v-.51h.765a.765.765,0,0,0,.255-.046Zm0-1.275a.255.255,0,0,1-.255.255H31.029a.255.255,0,0,1-.255-.255v-1.02a.255.255,0,0,1,.255-.255h6.121a.255.255,0,0,1,.255.255Zm0-1.785a.238.238,0,0,1-.112-.031l-.135-.268a.253.253,0,1,1,.247.3Z"
        transform="translate(-44.868 -23.839)"
        fill="#5a5656"
      />
      <path
        id="Path_1324"
        data-name="Path 1324"
        d="M11.946,7.865H6.708L6.335,7.7V7.335A2.055,2.055,0,0,0,7.289,6.08h.066a.763.763,0,0,0,.1-1.52l.339-.339a.263.263,0,0,0,.074-.181V3.275A1.275,1.275,0,0,0,6.59,2L2.87,2.228c-.088,0-.53-.182-.576-.106a.255.255,0,0,0-.01.248l.451.905-.2.4a.255.255,0,0,0,.046.3l.594.594a.763.763,0,0,0,.1,1.52h.066A2.055,2.055,0,0,0,4.3,7.335V7.7l-1.237.551A1.785,1.785,0,0,0,2,9.88v3.851a1.02,1.02,0,0,0,1.02,1.02v2.3a.255.255,0,0,0,.255.255h4.08a.255.255,0,0,0,.255-.255V9.4h5.1a.255.255,0,0,0,.255-.255V8.886A1.02,1.02,0,0,0,11.946,7.865ZM7.61,5.315a.255.255,0,0,1-.255.255V5.06A.255.255,0,0,1,7.61,5.315ZM3.275,5.57a.255.255,0,0,1,0-.51Zm-.2-1.836.171-.344a.244.244,0,0,0,0-.23l.094-.38L6.59,2.51a.767.767,0,0,1,.765.765v.661L7,4.3H6.958a.255.255,0,0,1-.242-.173L6.578,3.7a.249.249,0,0,0-.166-.161.267.267,0,0,0-.077-.013.262.262,0,0,0-.153.051l-.477.357A1.8,1.8,0,0,1,4.634,4.3h-1ZM3.785,5.57V4.805h.849a2.3,2.3,0,0,0,1.377-.459L6.205,4.2l.028.082a.759.759,0,0,0,.612.513V5.57a1.53,1.53,0,1,1-3.06,0Zm1.02,2.112V7.544a2,2,0,0,0,1.02,0v.138l-.51.171Zm.038.551-.291.288L4.3,8.256l.265-.117Zm1.224-.094.265.117-.255.265-.291-.288Zm-3.048,6.1a.512.512,0,0,1-.51-.51h.51Zm4.08,2.55H5.57v-2.04H5.06v2.04H3.53V13.986H7.1Zm4.335-7.906H7.355a.255.255,0,0,0-.255.255v4.335H3.53V9.651H3.02v3.57H2.51V9.88a1.277,1.277,0,0,1,.757-1.165L3.8,8.478l.564.584a.247.247,0,0,0,.181.079h0a.268.268,0,0,0,.181-.074l.584-.587.584.587a.268.268,0,0,0,.181.074h0a.247.247,0,0,0,.181-.079l.663-.686h4.509Zm.51,0v-.51a.512.512,0,0,1,.51.51Z"
        transform="translate(-24)"
        fill="#5a5656"
      />
      <path
        id="Path_1325"
        data-name="Path 1325"
        d="M42.95,3.043l-2.3-1.02a.25.25,0,0,0-.209,0l-2.3,1.02a.252.252,0,0,0-.15.232V4.79a3.313,3.313,0,0,0,1.706,2.9l.719.4a.252.252,0,0,0,.25,0l.719-.4A3.312,3.312,0,0,0,43.1,4.79V3.275a.252.252,0,0,0-.15-.232ZM42.59,4.79a2.81,2.81,0,0,1-1.443,2.453l-.6.332-.6-.332A2.81,2.81,0,0,1,38.51,4.79V3.441l2.04-.908,2.04.908Z"
        transform="translate(-50.819 0)"
        fill="#5a5656"
      />
      <path
        id="Path_1326"
        data-name="Path 1326"
        d="M44.238,12a.255.255,0,0,0,.18-.075l1.275-1.275-.361-.361-1.095,1.095-.585-.585-.361.361.765.765A.255.255,0,0,0,44.238,12Z"
        transform="translate(-54.762 -6.178)"
        fill="#5a5656"
      />
      <path
        id="Path_1328"
        data-name="Path 1328"
        d="M1.146,2.093,8,0,7.521,5.71,5.97,7.623,1.64,7.062Z"
        transform="translate(-23)"
        fill="#fff"
      />
      <g
        id="Path_1327"
        data-name="Path 1327"
        transform="translate(-21 4)"
        fill="#fff"
      >
        <path
          d="M 2.243652582168579 3.777588844299316 C 1.226632475852966 3.777588844299316 0.8642625212669373 2.859338998794556 0.8642625212669373 1.999998927116394 C 0.8642625212669373 1.137178897857666 1.226632475852966 0.2152089327573776 2.243652582168579 0.2152089327573776 C 3.17291259765625 0.2152089327573776 3.588862419128418 1.21203887462616 3.588862419128418 2.199949026107788 C 3.588862419128418 3.246798992156982 3.136272430419922 3.777588844299316 2.243652582168579 3.777588844299316 Z"
          stroke="none"
        />
        <path
          d="M 2.243652582168579 0.4652090072631836 C 1.19570255279541 0.4652090072631836 1.114262580871582 1.639948844909668 1.114262580871582 1.999998927116394 C 1.114262580871582 2.358358860015869 1.19570255279541 3.527588844299316 2.243652582168579 3.527588844299316 C 2.713812351226807 3.527588844299316 3.338862419128418 3.38995885848999 3.338862419128418 2.199948787689209 C 3.338862419128418 1.555639028549194 3.108192443847656 0.4652090072631836 2.243652582168579 0.4652090072631836 M 2.243652582168579 -0.03479099273681641 C 3.348222494125366 -0.03479099273681641 3.838862419128418 1.095378875732422 3.838862419128418 2.199948787689209 C 3.838862419128418 3.304518938064575 3.348222494125366 4.027588844299316 2.243652582168579 4.027588844299316 C 1.139082431793213 4.027588844299316 0.614262580871582 3.104568958282471 0.614262580871582 1.999998927116394 C 0.614262580871582 0.8954288959503174 1.139082431793213 -0.03479099273681641 2.243652582168579 -0.03479099273681641 Z"
          stroke="none"
          fill="#5a5656"
        />
      </g>
    </g>
  </SvgIcon>
);

export const AppLogoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 88.259 88.273">
    <path
      id="Vehicle_White_Logo"
      d="M395.776,176.414a27.329,27.329,0,0,1-27.111-25.533c-.02-.335-.041-.67-.048-1.009q-.008-.312-.008-.626c0-.6.021-1.215.062-1.827h14.576l1.462,3.462,6.952,16.469a4.513,4.513,0,0,0,4.12,2.736l.129,0a4.545,4.545,0,0,0,4.146-2.535l8.077-16.672,1.677-3.462h18.244l-.083-.969a32.035,32.035,0,0,0-1.374-6.925c-.073-.231-.154-.457-.232-.685a32.308,32.308,0,0,0-61.179,0h5.5a27.156,27.156,0,0,1,50.176,0c.172.413.338.83.49,1.255.257.716.484,1.443.679,2.173H409.506a4.609,4.609,0,0,0-4.152,2.535l-2.945,6.077-6.473,13.359-5.64-13.359-2.48-5.875a4.561,4.561,0,0,0-4.243-2.737H364.21l-.142.72a32.5,32.5,0,0,0-.488,3.462c-.081.94-.122,1.881-.122,2.8,0,.223,0,.444.009.665.006.325.027.647.043.97a32.308,32.308,0,0,0,64.532,0h-5.155A27.329,27.329,0,0,1,395.776,176.414Z"
      transform="translate(-223.982 -282.992) rotate(30)"
      fill="#149fcb"
    />
  </SvgIcon>
);

export const DownArrowOutlineIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 21.437 8.678">
    <g id="down" transform="translate(0.5 -116.741)">
      <path
        id="Path_1276"
        data-name="Path 1276"
        d="M19.692,117.369l-9.459,6.755L.774,117.369a.577.577,0,0,0-.628.008.257.257,0,0,0,0,.441L9.92,124.8a.578.578,0,0,0,.628,0l9.774-6.979a.258.258,0,0,0,.011-.449.577.577,0,0,0-.628-.008l-.011.008Z"
        transform="translate(-0.02 0)"
        fill="#149fcb"
        stroke="#149fcb"
        strokeWidth="1"
      />
      <path
        id="Path_1277"
        data-name="Path 1277"
        d="M10.213,124.891A.547.547,0,0,1,9.9,124.8L.124,117.819a.258.258,0,0,1,.011-.449.579.579,0,0,1,.617,0l9.46,6.755,9.459-6.755a.577.577,0,0,1,.628-.008.259.259,0,0,1,.011.449l-.011.008L10.526,124.8A.547.547,0,0,1,10.213,124.891Z"
        transform="translate(0 -0.001)"
        fill="#149fcb"
        stroke="#149fcb"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export const SaloonIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 90.616 36.25">
    <g id="surface1">
      <path
        id="Path_8"
        data-name="Path 8"
        className="cls-1"
        d="M515.294,471.032h-6.187v-3.094h6.187Z"
        transform="translate(-462.369 -454.376)"
      />
      <path
        id="Path_9"
        data-name="Path 9"
        className="cls-1"
        d="M212,392.256v12.233a5.711,5.711,0,0,0,3.608,5.33l4.892,1.963a1.515,1.515,0,0,0,.562.108h.542a9.028,9.028,0,0,0,17.04,0H279a9.028,9.028,0,0,0,17.04,0h5.071a1.51,1.51,0,0,0,1.511-1.511v-8.968a6.9,6.9,0,0,0-3.465-5.97,35.686,35.686,0,0,0-17.27-4.681l-5.177-2.824a51.336,51.336,0,0,0-24.513-6.251h-1.782a50.858,50.858,0,0,0-21.041,4.531,51.752,51.752,0,0,0-5.813,3.081L213.3,390.76A1.511,1.511,0,0,0,212,392.256Zm69.473,16.613a6.041,6.041,0,1,1,.122,1.208A6.041,6.041,0,0,1,281.474,408.869Zm-27.185-15.1h27.185a32.652,32.652,0,0,1,16.18,4.3,3.863,3.863,0,0,1,1.944,3.348v7.458h-3.02a9.062,9.062,0,1,0-18.123,0H254.29Zm0-9a48.29,48.29,0,0,1,20.97,5.816l.291.159H254.29Zm-3.021,5.975H235.281l-2.637-2.637a47.8,47.8,0,0,1,17.77-3.4h.855Zm-27.185,18.123a6.041,6.041,0,1,1,.122,1.208A6.04,6.04,0,0,1,224.084,408.869Zm-9.062-15.3,9.276-1.324a1.516,1.516,0,0,0,.586-.214,48.421,48.421,0,0,1,4.788-2.619l3.916,3.916a1.508,1.508,0,0,0,1.067.442h16.612v15.1H239.182a9.07,9.07,0,0,0-9.062-9.062,9.206,9.206,0,0,0-.921.047c-.112.01-.219.035-.331.05-.189.028-.379.049-.565.087-.116.024-.226.06-.341.087-.176.044-.352.082-.524.135-.128.041-.227.083-.378.138s-.324.111-.453.166-.237.113-.376.18-.291.135-.413.2-.228.131-.358.216-.265.155-.387.235-.235.173-.35.259-.231.162-.345.259-.227.209-.331.3-.206.177-.311.283-.208.234-.3.329-.184.186-.281.3-.191.248-.274.36-.163.21-.249.334-.169.261-.237.382-.148.231-.219.361-.133.27-.2.4-.135.252-.187.388-.1.278-.151.415-.106.272-.151.412-.076.286-.115.429-.084.3-.114.434-.048.288-.073.439-.054.3-.069.453-.018.314-.027.453-.027.277-.027.416l-4.332-1.74a2.7,2.7,0,0,1-1.71-2.523V398.3h4.531v-3.021h-4.531Z"
        transform="translate(-212.002 -381.684)"
      />
    </g>
    <path
      id="Path_10"
      data-name="Path 10"
      className="cls-1"
      d="M282.223,514.019a7.088,7.088,0,0,1-7.032-6.622c-.005-.087-.011-.174-.013-.262,0-.054,0-.108,0-.162,0-.156.005-.315.016-.474h3.78l.379.9,1.8,4.272a1.171,1.171,0,0,0,1.069.71h.033a1.179,1.179,0,0,0,1.075-.658l2.095-4.324.435-.9H290.6l-.022-.251a8.314,8.314,0,0,0-.356-1.8c-.019-.06-.04-.119-.06-.178a8.38,8.38,0,0,0-15.868,0h1.427a7.043,7.043,0,0,1,13.014,0c.045.107.088.216.127.326.067.186.126.374.176.564h-3.249a1.2,1.2,0,0,0-1.077.658l-.764,1.576-1.679,3.465L280.8,507.4l-.643-1.524a1.183,1.183,0,0,0-1.1-.71h-5.022l-.037.187a8.412,8.412,0,0,0-.127.9c-.021.244-.032.488-.032.725,0,.058,0,.115,0,.173,0,.084.007.168.011.252a8.38,8.38,0,0,0,16.737,0h-1.337A7.088,7.088,0,0,1,282.223,514.019Z"
      transform="translate(-263.86 -479.845)"
    />
    <path
      id="Path_11"
      data-name="Path 11"
      className="cls-1"
      d="M647.687,514.019a7.088,7.088,0,0,1-7.032-6.622c-.005-.087-.011-.174-.013-.262,0-.054,0-.108,0-.162,0-.156.006-.315.016-.474h3.78l.379.9,1.8,4.272a1.171,1.171,0,0,0,1.069.71h.034a1.178,1.178,0,0,0,1.075-.658l2.095-4.324.435-.9h4.732l-.022-.251a8.339,8.339,0,0,0-.356-1.8c-.019-.06-.04-.119-.06-.178a8.38,8.38,0,0,0-15.868,0h1.427a7.043,7.043,0,0,1,13.014,0c.045.107.087.216.127.326.067.186.126.374.176.564h-3.249a1.2,1.2,0,0,0-1.077.658l-.764,1.576-1.679,3.465-1.463-3.465-.643-1.524a1.183,1.183,0,0,0-1.1-.71H639.5l-.037.187a8.4,8.4,0,0,0-.127.9c-.021.244-.032.488-.032.725,0,.058,0,.115,0,.173,0,.084.007.168.011.252a8.38,8.38,0,0,0,16.737,0h-1.337A7.088,7.088,0,0,1,647.687,514.019Z"
      transform="translate(-572.534 -479.845)"
    />
  </SvgIcon>
);

export const LorryIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 87.559 46.907">
    <g id="Group_5" data-name="Group 5">
      <path
        d="M336.391,60.015l-.006-.255-.185-.189-4.888-11.348a1.853,1.853,0,0,0-1.661-1.007H314.156a1.822,1.822,0,0,0-1.84,1.8V70.8a9.129,9.129,0,0,0-1.161.972h-3.147l1.124-.954a1.777,1.777,0,0,0,.55-1.282V45.385a1.815,1.815,0,0,0-1.839-1.786H277.271l-3.157-3.105-.179-.151a1.9,1.9,0,0,0-1.133-.375h-4.474a1.83,1.83,0,0,0-1.855,1.8v5.07L253.338,64.163h-2.39a1.822,1.822,0,0,0-1.84,1.8v6.522a1.816,1.816,0,0,0,1.373,1.733l1.468.382L255.9,80.07a1.874,1.874,0,0,0,1.453.692h5.8a9.109,9.109,0,0,0,17.2,0H309.01a9.109,9.109,0,0,0,17.2,0h5.541a1.913,1.913,0,0,0,1.336-.549l2.88-3.513a1.706,1.706,0,0,0,.429-1.143V60.938l.267-.281Zm-14.863,9.977V61.876h11.754V71.77h-9.213A9.094,9.094,0,0,0,321.528,69.992ZM332.514,58.85H321.528V50.242h7.277Zm-17.079-8.608h2.977v18.9c-.264-.023-.529-.04-.8-.04a9.188,9.188,0,0,0-2.178.271ZM299.447,75.453a1.536,1.536,0,0,0-1.559,1.513v.769h-6.163v-.769a1.559,1.559,0,0,0-3.118,0v.769H280.8a8.672,8.672,0,0,0-.6-2.939h28.97a8.672,8.672,0,0,0-.6,2.939h-7.561v-.769A1.537,1.537,0,0,0,299.447,75.453ZM269.285,48.232a1.772,1.772,0,0,0,.306-1V42.994h2.685l2.509,2.468-1.018,3.7L262.143,64.171H257.2ZM252.226,67.189h1.746c.049,0,.1-.012.145-.016V67.2h8.662a1.875,1.875,0,0,0,1.474-.714l12.173-15.719a1.76,1.76,0,0,0,.346-.8l.921-3.342h28.872V68.98l-3.293,2.791h-25.06a9.159,9.159,0,0,0-12.914,0H253.11l-.885-.23ZM255.9,74.8h7.414a8.67,8.67,0,0,0-.6,2.939h-4.69Zm15.858,9.052a5.858,5.858,0,1,1,5.941-5.857A5.906,5.906,0,0,1,271.755,83.849Zm45.857,0a5.858,5.858,0,1,1,5.941-5.857A5.907,5.907,0,0,1,317.613,83.849Zm13.536-6.113h-4.49a8.677,8.677,0,0,0-.6-2.939h7.227v.323Z"
        transform="translate(-249.108 -39.968)"
      />
      <path
        d="M406.059,135.463a1.656,1.656,0,0,0,1.291-.61l6.944-8.606a1.56,1.56,0,0,0-.279-2.234,1.672,1.672,0,0,0-2.3.271l-6.943,8.606a1.56,1.56,0,0,0,.279,2.234A1.663,1.663,0,0,0,406.059,135.463Z"
        transform="translate(-380.011 -110.647)"
      />
      <path
        d="M457.7,135.124a1.673,1.673,0,0,0,2.3-.271l6.943-8.606a1.56,1.56,0,0,0-.279-2.234,1.672,1.672,0,0,0-2.3.271l-6.943,8.606A1.56,1.56,0,0,0,457.7,135.124Z"
        transform="translate(-424.385 -110.647)"
      />
      <path
        d="M510.346,135.124a1.673,1.673,0,0,0,2.3-.271l6.944-8.606a1.56,1.56,0,0,0-.279-2.234,1.672,1.672,0,0,0-2.3.271l-6.944,8.606A1.56,1.56,0,0,0,510.346,135.124Z"
        transform="translate(-468.758 -110.647)"
      />
      <path
        d="M716.652,187.793H714.3a1.592,1.592,0,1,0,0,3.182h2.351a1.592,1.592,0,1,0,0-3.182Z"
        transform="translate(-640.068 -164.492)"
      />
    </g>
    <path
      d="M353.552,246.471a6.539,6.539,0,0,1-6.487-6.109c0-.08-.01-.161-.012-.241,0-.05,0-.1,0-.15,0-.144,0-.291.015-.437h3.487l.35.828,1.663,3.94a1.08,1.08,0,0,0,.986.655h.031a1.087,1.087,0,0,0,.992-.607l1.933-3.989.4-.828h4.365l-.02-.232a7.777,7.777,0,0,0-.117-.828,7.691,7.691,0,0,0-.212-.829c-.017-.055-.037-.109-.056-.164a7.73,7.73,0,0,0-14.638,0h1.316a6.5,6.5,0,0,1,12.006,0c.041.1.081.2.117.3.062.171.116.345.162.52h-3a1.1,1.1,0,0,0-.993.606l-.7,1.454-1.549,3.2-1.349-3.2-.594-1.406a1.091,1.091,0,0,0-1.015-.655H346l-.034.172a7.714,7.714,0,0,0-.117.828c-.02.225-.029.45-.029.669,0,.053,0,.106,0,.159,0,.078.006.155.01.232a7.73,7.73,0,0,0,15.44,0h-1.233A6.539,6.539,0,0,1,353.552,246.471Z"
      transform="translate(-330.68 -202.675)"
    />
    <path
      d="M643.445,247.471a6.539,6.539,0,0,1-6.487-6.109c0-.08-.01-.161-.012-.241,0-.05,0-.1,0-.15,0-.144.005-.291.015-.437h3.487l.35.828,1.663,3.941a1.08,1.08,0,0,0,.986.655h.031a1.087,1.087,0,0,0,.992-.607l1.933-3.989.4-.828h4.365l-.02-.232a7.665,7.665,0,0,0-.329-1.657c-.018-.055-.037-.109-.055-.164a7.73,7.73,0,0,0-14.638,0h1.317a6.5,6.5,0,0,1,12.005,0c.041.1.081.2.117.3.061.171.116.345.162.52h-3a1.1,1.1,0,0,0-.993.606l-.7,1.454-1.549,3.2-1.349-3.2-.593-1.406a1.091,1.091,0,0,0-1.015-.655h-4.633l-.034.172a7.729,7.729,0,0,0-.117.828c-.019.225-.029.45-.029.669,0,.053,0,.106,0,.159,0,.078.006.155.01.232a7.73,7.73,0,0,0,15.44,0h-1.233A6.539,6.539,0,0,1,643.445,247.471Z"
      transform="translate(-575.177 -203.508)"
    />
  </SvgIcon>
);

export const VanIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 87.559 46.907">
    <path
      d="M313.454,671.915l-4.488-13.977a7.13,7.13,0,0,0-6.816-4.946H231.842a5.077,5.077,0,0,0-5.095,5.048v29.238a4.372,4.372,0,0,0,4.383,4.352h6.007a8.454,8.454,0,0,0,16.335,0h30.74a8.453,8.453,0,0,0,16.334,0h9.718a3.2,3.2,0,0,0,3.206-3.19V672.35Zm-83.61-13.875a1.977,1.977,0,0,1,2-1.951H302.15a4.037,4.037,0,0,1,3.864,2.788l.062.193H229.844Zm57.538,8.68a1.548,1.548,0,0,0-1.549,1.549v4.246h-1.42V662.168h10.545v10.347H288.93v-4.246A1.548,1.548,0,0,0,287.382,666.721Zm-13.464,0a1.548,1.548,0,0,0-1.549,1.549v4.246h-1.6V662.168h10.545v10.347h-5.849v-4.246A1.548,1.548,0,0,0,273.918,666.721Zm-13.376,0a1.548,1.548,0,0,0-1.549,1.549v4.246h-1.865V662.168h10.545v10.347H262.09v-4.246A1.548,1.548,0,0,0,260.541,666.721Zm-13.82,0a1.548,1.548,0,0,0-1.549,1.549v4.246h-1.686V662.168h10.544v10.347h-5.76v-4.246A1.548,1.548,0,0,0,246.722,666.721Zm-16.877-4.553H240.39v10.347h-5.939v-4.246a1.549,1.549,0,1,0-3.1,0v4.246h-1.509ZM245.3,694.8a5.281,5.281,0,1,1,5.352-5.28A5.322,5.322,0,0,1,245.3,694.8ZM284,688.533H253.688a8.451,8.451,0,0,0-16.768,0h-5.79a1.271,1.271,0,0,1-1.286-1.254V675.612h64.933V681.5A8.446,8.446,0,0,0,284,688.533Zm8.383,6.272a5.281,5.281,0,1,1,5.35-5.28A5.322,5.322,0,0,1,292.379,694.8Zm17.885-6.272h-9.5a8.343,8.343,0,0,0-2.887-5.358v-6.552l3.063,1.608a4.82,4.82,0,0,0,2.234.55h7.159Zm.088-12.849h-7.18a1.722,1.722,0,0,1-.449-.064v-4.829a1.549,1.549,0,1,0-3.1,0v3.254l-1.568-.823V662.168h9.006l3.31,10.393Z"
      transform="translate(-226.747 -652.992)"
    />
    <path
      d="M741.851,842.552h-1.426a1.559,1.559,0,0,0,0,3.118h1.426a1.559,1.559,0,1,0,0-3.118Z"
      transform="translate(-666.794 -815.852)"
    />
    <path
      d="M318.57,877.887a5.576,5.576,0,0,1-5.531-5.209c0-.068-.008-.137-.01-.206,0-.042,0-.085,0-.128,0-.123,0-.248.013-.373h2.974l.3.706,1.419,3.36a.921.921,0,0,0,.841.558h.026a.927.927,0,0,0,.846-.517l1.648-3.4.342-.706h3.722l-.017-.2a6.535,6.535,0,0,0-.28-1.413c-.015-.047-.031-.093-.047-.14a6.592,6.592,0,0,0-12.482,0h1.122a5.54,5.54,0,0,1,10.237,0c.035.084.069.169.1.256.052.146.1.294.138.443h-2.556a.94.94,0,0,0-.847.517l-.6,1.24L318.6,875.4l-1.151-2.726-.506-1.2a.93.93,0,0,0-.866-.558h-3.951l-.029.147a6.59,6.59,0,0,0-.1.706c-.016.192-.025.384-.025.57,0,.046,0,.091,0,.136,0,.066.005.132.009.2a6.592,6.592,0,0,0,13.166,0H324.1A5.576,5.576,0,0,1,318.57,877.887Z"
      transform="translate(-299.886 -835.867)"
    />
    <path
      d="M652.622,877.887a5.576,5.576,0,0,1-5.531-5.209c0-.068-.008-.137-.01-.206,0-.042,0-.085,0-.128,0-.123,0-.248.013-.373h2.974l.3.706,1.418,3.36a.921.921,0,0,0,.841.558h.026a.927.927,0,0,0,.846-.517l1.648-3.4.342-.706h3.722l-.017-.2a6.53,6.53,0,0,0-.28-1.413c-.015-.047-.031-.093-.047-.14a6.592,6.592,0,0,0-12.482,0H647.5a5.54,5.54,0,0,1,10.237,0c.035.084.069.169.1.256.052.146.1.294.138.443h-2.556a.94.94,0,0,0-.847.517l-.6,1.24-1.321,2.726-1.151-2.726-.506-1.2a.93.93,0,0,0-.866-.558h-3.951l-.029.147a6.613,6.613,0,0,0-.1.706c-.016.192-.025.384-.025.57,0,.046,0,.091,0,.136,0,.066.006.132.009.2a6.592,6.592,0,0,0,13.166,0h-1.052A5.576,5.576,0,0,1,652.622,877.887Z"
      transform="translate(-587.012 -835.867)"
    />
  </SvgIcon>
);

export const TraficSingleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 27.42 41.535">
    <g transform="translate(-81.56)">
      <g transform="translate(81.56)">
        <path
          d="M299.637,64a2.077,2.077,0,1,0,2.077,2.077A2.077,2.077,0,0,0,299.637,64Zm0,2.769a.692.692,0,1,1,.692-.692A.692.692,0,0,1,299.637,66.769Z"
          transform="translate(-278.869 -58.462)"
          fill="#5a5656"
        />
        <path
          d="M299.637,120a2.077,2.077,0,1,0,2.077,2.077A2.077,2.077,0,0,0,299.637,120Zm0,2.769a.692.692,0,1,1,.692-.692A.692.692,0,0,1,299.637,122.769Z"
          transform="translate(-278.869 -109.616)"
          fill="#5a5656"
        />
        <path
          d="M299.637,176a2.077,2.077,0,1,0,2.077,2.077A2.077,2.077,0,0,0,299.637,176Zm0,2.769a.692.692,0,1,1,.692-.692A.692.692,0,0,1,299.637,178.769Z"
          transform="translate(-278.869 -160.77)"
          fill="#15b762"
        />
        <path
          d="M106.849,12.347a2.069,2.069,0,0,1,1.439-.579.692.692,0,1,0,0-1.385,3.438,3.438,0,0,0-1.807.516V7.854l.368-.354a2.069,2.069,0,0,1,1.439-.577.692.692,0,1,0,0-1.385,3.438,3.438,0,0,0-1.807.516V5.538A2.077,2.077,0,0,0,104.4,3.461H103.02V1.385h2.769a.692.692,0,0,0,0-1.385H91.944a6.237,6.237,0,0,0-6.23,6.23V32.536a2.077,2.077,0,0,0-2.077,2.077v3.461H82.252a.692.692,0,0,0-.692.692v2.077a.692.692,0,0,0,.692.692h8.307a.692.692,0,0,0,.692-.692V38.766a.692.692,0,0,0-.692-.692H89.175V34.613A2.077,2.077,0,0,0,87.1,32.536V6.23a4.852,4.852,0,0,1,4.846-4.846h9.692V3.461h-1.385a2.077,2.077,0,0,0-2.077,2.077v.516a3.438,3.438,0,0,0-1.807-.516.692.692,0,1,0,0,1.385,2.067,2.067,0,0,1,1.439.579l.368.353V10.9a3.438,3.438,0,0,0-1.807-.517.692.692,0,1,0,0,1.385,2.067,2.067,0,0,1,1.439.579l.368.353v3.046a3.438,3.438,0,0,0-1.807-.517.692.692,0,1,0,0,1.385,2.067,2.067,0,0,1,1.439.579l.368.353v1.837a2.077,2.077,0,0,0,2.077,2.077H104.4a2.077,2.077,0,0,0,2.077-2.077V17.547l.368-.354a2.069,2.069,0,0,1,1.439-.579.692.692,0,1,0,0-1.385,3.438,3.438,0,0,0-1.807.516V12.7ZM89.867,39.459v.692H82.945v-.692ZM87.79,34.613v3.461H85.021V34.613a.692.692,0,0,1,.692-.692H87.1A.692.692,0,0,1,87.79,34.613ZM105.1,19.383a.692.692,0,0,1-.692.692h-4.154a.692.692,0,0,1-.692-.692V5.538a.692.692,0,0,1,.692-.692H104.4a.692.692,0,0,1,.692.692Z"
          transform="translate(-81.56 0)"
          fill="#5a5656"
        />
      </g>
    </g>
  </SvgIcon>
);

export const ChevronRightIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 9.474 5.21">
    <path
      d="M.138,5.075,4.394,9.334a.478.478,0,0,0,.676-.676L1.152,4.737,5.07.816A.478.478,0,0,0,4.393.14L.138,4.4A.483.483,0,0,0,.138,5.075Z"
      transform="translate(0 5.21) rotate(-90)"
      fill="#5a5656"
    />
  </SvgIcon>
);

export const UpAndDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 9.395 12.974">
    <path
      d="M96.724,29.368a.669.669,0,0,1-.475-.2L92.7,25.619l-3.552,3.552a.671.671,0,1,1-.949-.949L92.223,24.2a.671.671,0,0,1,.949,0L97.2,28.222a.671.671,0,0,1-.475,1.146Zm-3.552,7.409L97.2,32.75a.671.671,0,0,0-.949-.949L92.7,35.353,89.145,31.8a.671.671,0,0,0-.949.949l4.027,4.027A.671.671,0,0,0,93.172,36.777Z"
      transform="translate(-87.999 -23.999)"
    />
  </SvgIcon>
);
